<template>
  <div class="not-for-screen-render">
    <!-- Cover Pages  -->
     <!-- Cover Page for User Performance Report -->
    <div ref="coverPageAdvanceReport" :style="{
      position: 'relative',
      height: '100%',
      width: '100%',
      backgroundColor: 'white'
    }">
    <img :src="coverPageAdvanceReport" style="position: absolute; z-index: 0; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;"/>
    
    <div style="position: absolute; z-index: 1000; top: 730px; left: 192px;
        font-size: 32px; color: #2E5EAB; font-style: italic; 
        font-family: 'GraphikRegular', sans-serif; font-weight: 400;">
      {{ currentDate }}
    </div>
    </div>

    <div ref="coverPageBasicReport" :style="{
      position: 'relative',
      height: '100%',
      width: '100%',
      backgroundColor: 'white'
    }">
    <img :src="coverPageBasicReport" style="position: absolute; z-index: 0; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;"/>
    
    <div style="position: absolute; z-index: 1000; top: 730px; left: 192px;
        font-size: 32px; color: #2E5EAB; font-style: italic; 
        font-family: 'GraphikRegular', sans-serif; font-weight: 400;">
      {{ currentDate }}
    </div>
    </div>

    <!-- Cover Page for Leadership Advance Report -->
    <div ref="coverPageLeadershipReport" :style="{
      position: 'relative',
      height: '100%',
      width: '100%',
      backgroundColor: 'white'
    }">
    <img :src="coverPageLeadershipReport" style="position: absolute; z-index: 0; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;"/>
    
    <div style="position: absolute; z-index: 1000; top: 730px; left: 100px;
        font-size: 32px; color: #2E5EAB; font-style: italic; 
        font-family: 'GraphikRegular', sans-serif; font-weight: 400;">
      <span>Date:</span> {{ currentDate }}
    </div>

    </div>


    <!-- Cover Page for Communication Skills Advance Report -->
    <div ref="coverPageCommunicationSkillsAdvance" :style="{
      position: 'relative',
      height: '100%',
      width: '100%',
      backgroundColor: 'white'
    }">
    <img :src="coverPageCommunicationSkillsAdvance" style="position: absolute; z-index: 0; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;"/>
    
    <div style="position: absolute; z-index: 1000; top: 730px; left: 192px;
        font-size: 32px; color: #2E5EAB; font-style: italic; 
        font-family: 'GraphikRegular', sans-serif; font-weight: 400;">
      {{ currentDate }}
    </div>
    </div>
     <!-- Cover Page for Communication Skills Basic Report -->
    <div ref="coverPageCommunicationSkillsBasic" :style="{
      position: 'relative',
      height: '100%',
      width: '100%',
      backgroundColor: 'white'
    }">
    <img :src="coverPageCommunicationSkillsBasic" style="position: absolute; z-index: 0; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;"/>
    
    <div style="position: absolute; z-index: 1000; top: 730px; left: 192px;
        font-size: 32px; color: #2E5EAB; font-style: italic; 
        font-family: 'GraphikRegular', sans-serif; font-weight: 400;">
      {{ currentDate }}
    </div>
    </div>
    
    <!-- Cover Page for Communication Skills Advance Report -->
    <div ref="coverPageDigitalLiteracyAdvance" :style="{
      position: 'relative',
      height: '100%',
      width: '100%',
      backgroundColor: 'white'
    }">
    <img :src="coverPageDigitalLiteracyAdvance" style="position: absolute; z-index: 0; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;"/>
    
    <div style="position: absolute; z-index: 1000; top: 730px; left: 192px;
        font-size: 32px; color: #2E5EAB; font-style: italic; 
        font-family: 'GraphikRegular', sans-serif; font-weight: 400;">
      {{ currentDate }}
    </div>
    </div>
     <!-- Cover Page for Communication Skills Basic Report -->
    <div ref="coverPageDigitalLiteracyBasic" :style="{
      position: 'relative',
      height: '100%',
      width: '100%',
      backgroundColor: 'white'
    }">
    <img :src="coverPageDigitalLiteracyBasic" style="position: absolute; z-index: 0; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;"/>
    
    <div style="position: absolute; z-index: 1000; top: 730px; left: 192px;
        font-size: 32px; color: #2E5EAB; font-style: italic; 
        font-family: 'GraphikRegular', sans-serif; font-weight: 400;">
      {{ currentDate }}
    </div>
    </div>

    <!-- Cover Page for GTO Report -->
    <div ref="coverPageGto" :style="{
      position: 'relative',
      height: '100%',
      width: '100%',
      backgroundColor: 'white'
    }">
      <img :src="coverPageGto" style="position: absolute; z-index: 0; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;"/>
    </div>


    <!-- Understand Your Report -->
    <div ref="understandYourAdvanceReport" :style="{
    height: '100%',
    backgroundColor: 'white'
    }">   
      <img :src="understandYourAdvanceReport" 
      style="width: 100%; height: 100%;"/>
    </div>

    <div ref="understandYourBasicReport" :style="{
    height: '100%',
    backgroundColor: 'white'
    }">   
      <img :src="understandYourBasicReport" 
      style="width: 100%; height: 100%;"/>
    </div>

    <div ref="understandYourLeadershipReport" style="height: '100%'; background-color: 'white'; display: flex; flex-direction: column; justify-content: start;">   
      <img :src="understandYourLeadershipReport" 
      style="width: 100%; height: 100%;"/>
    </div>

    <!-- Understand Your Report:- Communication Skills -->
    <div ref="understandYourAdvanceCommunicationSkillsReport" :style="{
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      paddingTop: '36px'
      }">   
        <img :src="understandYourAdvanceCommunicationSkillsReport" 
        style="width: 100%; height: 100%;"/>
    </div>

    <!-- Understand Your Report :- Digital Literacy -->
    <div ref="understandYourAdvanceDigitalLiteracyReport" :style="{
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      paddingTop: '36px'
      }">   
        <img :src="understandYourAdvanceDigitalLiteracyReport" 
        style="width: 100%; height: 100%;"/>
    </div>

    <!-- Understand Your GTO Report -->
    <div ref="understandYourGtoReport" :style="{
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      paddingTop: '36px'
      }">   
        <img :src="understandYourGtoReport" 
        style="width: 100%; height: 100%;"/>
    </div>

    <!-- Index -->
    <div ref="userPerformanceReportIndex" style="display:flex; flex-direction:column; gap:24px; padding:0px 10px">
      <div style="display:flex; justify-content:center; font-size:20px; font-weight:550">Index</div>
      <!-- Section -->
      <div style="display:flex; flex-direction: column;
       box-shadow: 0px 2px 10px 0px #0000001F;
       padding:24px;
       border-radius: 8px !important;
       gap:24px">
        <div style="display:flex; flex-direction: column; margin-bottom: 16px; gap: 16px">
          <div style="display:flex;">
            <span  style="font-size:16px;">1. Understanding your report</span>
            <span :style="getDottedSeparator(16)"></span>
            <span>01</span>
          </div>
        </div>
        <!-- Section -->
        <div style="display:flex; flex-direction: column; margin-bottom: 16px; gap:16px">
          <div style="display:flex;">
            <span style="font-size:16px;">2. Performance at Glance</span>
            <span :style="getDottedSeparator(16)"></span>
            <span>02</span>
          </div>
          <!-- Sub-sections -->
          <div style="display:flex; flex-direction: column; padding-left:30px; gap: 16px;">
            <div style="display:flex; margin-bottom:4px">
              <span style="font-size:14px;">2.1. Assessment Analysis</span>
              <span :style="getDottedSeparator(14)"></span>
              <span>02</span>
            </div>
            <div style="display:flex; margin-bottom:4px">
              <span style="font-size:14px;">2.2. Achievement Marker</span>
              <span :style="getDottedSeparator(14)"></span>
              <span>03</span>
            </div>
            <div style="display:flex; margin-bottom:4px">
              <span style="font-size:14px;">2.3. Assessment completion time</span>
              <span :style="getDottedSeparator(14)"></span>
              <span>03</span>
            </div>
            <div v-if="!isFocusedReport" style="display:flex; margin-bottom:4px">
              <span style="font-size:14px;">2.4. Skill-wise Score Distribution</span>
              <span :style="getDottedSeparator(14)"></span>
              <span>04</span>
            </div>
          </div>
        </div>

         <!-- Section -->
         <div style="display:flex; flex-direction: column; gap:16px">
          <div style="display:flex;">
            <span style="font-size:16px;">3. Detailed Report</span>
            <span :style="getDottedSeparator(16)"></span>
            <span v-if="isFocusedReport">04</span>
            <span v-else> 05</span>
          </div>
          <!-- Sub-sections --> 
          <div style="display:flex; flex-direction: column; gap:16px; padding-left:30px">
            <div v-for="(skill, index) in advanceReportSkillsSections" :key="`index-skillsSections-${index}`" 
              style="display:flex; flex-direction:column; gap: 16px; width:100%;">
              <div style="display:flex;">
                <span style="font-size:14px;"> {{` 3.${index+1} ${skill.title}`}}</span>
                <span :style="getDottedSeparator(14)"></span>
                <span>{{ padWithZero(skill.pageNumber) }}</span>
              </div>
              <div style="display:flex; flex-direction:column; gap:16px; padding-left:30px;" v-if="skill.title == 'Core Skills'">
                <div v-for="(subject, i) in advanceReportSubSection" 
                :key="`index-subjectsSubSection-${i}`" style="display:flex; width:100%;">
                  <span style="font-size:12px;"> {{` 3.1.${i+1} ${subject.title.split('-')[1]}`}}</span>
                  <span :style="getDottedSeparator(12)"></span>
                  <span>{{ padWithZero(subject.pageNumber) }}</span>
                </div>
              </div>
              <div style="display:flex; flex-direction:column; gap:16px; padding-left:30px;" v-if="skill.title == 'Strand-wise Performance'">
                <div v-for="(strand, i) in advanceReportSubSection"
                :key="`index-strandsSubSection-${i}`" style="display:flex; width:100%;">
                  <span style="font-size:12px;"> {{` 3.3.${i+1} ${strand.title}`}}</span>
                  <span :style="getDottedSeparator(12)"></span>
                  <span>{{ padWithZero(strand.pageNumber) }}</span>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <!-- Section -->
        <div v-if="recommendationLinks.length > 0" style="display:flex; font-size:16px; margin-top: 16px;">
          <span>4. Recommendations For you</span>
          <span :style="getDottedSeparator(16)"></span>
          <span>{{padWithZero(allSections?.find(({title})=>title == "recommendationLinks")?.pageNumber)}}</span>
        </div>
      </div>
    </div>
    <div ref="wrapperTemplateUserPerformanceReport">
      <div class="page-wrapper" style="
        display:flex;
        flex-direction:column;
        background-color: white;
        font-family: 'GraphikRegular', sans-serif;
        width: 794px;
        height: 100%;
        break-inside: avoid;
      "> 
      
      <!-- Header UserPerformanceReport-->
        <div style="margin: 16px 16px 0px; width:100%; display:flex; justify-content:space-between; align-items:center; background-color: white; padding-right:16px;">
          <div style="color: #A3A3A3; font-size: 16px; font-weight: 400; padding-left:16px">{{ userInfo?.name }}</div>
          <img style="
          height:48px;
          width: 200px;" 
          :src="userPerformanceReportHeaderImage" alt=""/>
        </div>

      <!-- Page Content UserPerformanceReport -->
        <div style="margin:16px; flex: 1; height:100%; width: 794px;  overflow:auto; font-family: 'GraphikRegular', sans-serif;">
          userPerformanceReportContent
        </div>

      <!-- Footer UserPerformanceReport -->
        <div style="width: 826px; background-color: white;">
          <div style="display: flex; justify-content:space-between;">
            <div style="padding: 8px 32px; display: grid; place-items: center;">userPerformanceReportPageNumber</div>
            <div>
              <img style="height: 64px; width: 200px" :src="userPerformanceReportFooterImage"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="userPerformanceReport1" class="user-performance-report" 
      style="display: flex; 
      flex-direction:column;
      padding:10px 16px;
      gap: 16px;
      ">
        <div style="display: flex; flex-direction:row; flex-grow: 1; align-items: stretch; justify-content: center; width:100%; gap: 16px; margin-bottom: 26px;">
          <div style="width:100%; display: flex; border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F; padding:14px;">
            <img v-if="userInfo?.proctoringPic" style="height: 70px; width: 70px; border-radius: 35px;" :src="userInfo?.proctoringPic" alt="">
            <img v-else style="height: 70px; width: 70px; border-radius: 35px; " :src="userAvatarPlaceholder"/>
            <div style="display:flex; flex-direction:column; justify-content: space-evenly; margin-left:32px;">
              <div style="font-size:16px; font-weight:400;">{{ userInfo?.name }}</div>
              <!-- <div style="display: flex; align-items:center">
                <div style="font-size:14px; font-weight:400;">IIEP Rank</div>
                <div
                style="
                height: 32px;
                margin-left:8px;
                display:flex;
                justify-content:center;
                align-items:center;
                border-radius:16px; 
                background-color:#E1E8F5;
                color:#3F41D1;
                padding: 0px 16px;
                font-size:12px;
                font-weight:400;"> 
                  #3424
                </div>
              </div> -->
            </div>
          </div>
          <div style="
            width:100%;
            font-size:14px;
            font-weight:400;
            display:flex;
            flex-direction:column;
            justify-content: space-evenly;
            border-radius: 8px !important; 
            box-shadow: 0px 2px 10px 0px #0000001F;
            padding:16px 20px">
            <div style="display:flex; flex-direction: row; align-items: center; gap:32px">
              <div style="width:25%; display:flex; justify-content:space-between;">
                <span>
                Email
                </span>
                <span>
                  -
                </span>
              </div>
              <div>
                {{ userInfo?.email }}
              </div>
            </div>
            <div style="display:flex; flex-direction: row; align-items: center; gap:32px">
              <div style="width:25%; display:flex; justify-content:space-between;">
                <span>
                  Mobile
                </span>
                <span>
                  -
                </span>
              </div>
              <div>
                {{ userInfo?.phone }}
              </div>
            </div>
          </div>
        </div>
        <div style="display:flex; flex-direction:column; border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F; padding: 20px; gap:8px; margin-bottom: 16px;">
          <div v-if="!isFocusedReport" style="display:flex; flex-direction:row; gap:16px">
            <div style="display:flex; flex-direction:row; align-items:center; width:25%;">
              <div style="font-size:16px; font-weight:400; flex: 1;">Level</div>
              <div style="margin-right:16px;">-</div>
            </div>
            <div style="width:70%; display:flex; flex-direction:row; align-items:center;">
              <div v-for="(level, index) in userInfo?.levels" :key="`userPerformanceReport1-levels-${index}`"
                style="
                height: 32px;
                display:flex;
                justify-content:center;
                align-items:center;
                border: 0.5px solid #3F41D1; 
                border-radius:16px; 
                background-color:#E1E8F5;
                color:#3F41D1;
                padding: 0px 16px;
                font-size:12px;
                font-weight:400;">
                  {{  nameAliases?.levels?.[level] || level }}
              </div>
            </div>
          </div>
          <div style="display:flex; flex-direction:row; gap:16px">
            <div style="display:flex; flex-direction:row; justify-content:space-between; padding-top: 8px;"  :style="`width:${isFocusedReport? '10%': '25%'}`">
              <div style="font-size:16px; font-weight:400; flex: 1;">{{ isFocusedReport? 'Skill' : 'Subjects/Skills' }}</div>
              <div style="margin-right:16px;">-</div>
            </div>
            <div style="max-width:70%; display: flex; flex-wrap: wrap;">
              <div v-for="(subject, index) in userInfo.skillsToShow" :key="`userPerformanceReport1-skillsToShow-${index}`"
              style="
              height: 32px;
              display:flex;
              justify-content:center;
              align-items:center;
              border: 0.5px solid #3F41D1; 
              border-radius:16px; 
              background-color:#E1E8F5;
              color:#3F41D1;
              padding: 0px 16px;
              margin: 0px 8px 8px 0px;
              font-size:12px;
              font-weight:400;">
                {{ subject }}
              </div>
            </div>
          </div>
        </div>
        <div style="margin-bottom: 16px;">
          <div style="font-size:24px; font-weight: 600; margin-bottom: 26px;">Performance at a Glance</div>
          <div style="display:flex; flex-direction:column; border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F; padding:16px; gap:8px;">
            <div style="font-size: 18px; font-weight: 600;">Assessment Analysis</div>
            <div style="position: relative; display:flex; justify-content:center; align-items:center;">
              <!-- Radial Bar Chart -->
              <VueApexCharts
                type="radialBar"
                :options="overallAssessmentChartOptions"
                :series="overallAssessmentChartData"
                :width="600"
                :height="600"
              />
          
              <!-- Overlay Labels -->
              <div
                v-for="(value, index) in overallAssessmentChartData"
                :key="`userPerformanceReport1-overallAssessmentChartData-${index}`"
                :style="getLabelStyle(index)"
                style="pointer-events: none;"
              >
                {{ value }}%
              </div>
            </div>
          </div>
        </div>
    </div>
    <div ref="userPerformanceReport2" class="user-performance-report" style="width:700px !important; height:100%; padding:16px;gap: 16px;"> 
      <div style="width:100% !important; display: flex; flex-direction:column; border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F; padding:16px;  margin-bottom: 20px;">
        <div style="font-size: 18px; font-weight: 550;">Achievement Marker</div>
        <div style="
        font-size: 12px;
        font-weight: 400;
        padding-bottom: 8px;
        color:#666666">
          Indicates your score and the highest score overall
        </div>
        <div style="display: flex; justify-content:center;">
          <div style="display: flex; flex-direction:column; justify-content:center; width:90%;">
            <div style="display: flex; width:26px; align-items:center; flex-direction:column; gap: 4px; position:relative; transform: translateX(-13px)" 
            :style="`left:${getPercentage(scoreProfile?.userScore, scoreProfile?.maximumMarks)}%`">
              <div style="font-size: 12px;">
                {{ scoreProfile?.userScore }}
              </div>
              <img
              :src="yourScoreImage"
              alt="pass icon"
              style="width:26px; height:24px; transform:rotate(180deg);"
              />
            </div>
            <div style="width:100%; height: 40px; background-color: #E0E0E0; border-radius:20px;">
              <div style="position:relative; left:0;height: 40px; background-color: #06C270;"
              :style="`
              width:${getPercentage(scoreProfile?.userScore, scoreProfile?.maximumMarks)}%;
              border-radius: ${scoreProfile?.userScore == scoreProfile?.maximumMarks? '20px':'20px 0px 0px 20px'};
              `">
              </div>
            </div>
            <div style="display: flex; width:26px; align-items:center; flex-direction:column; gap: 4px; position:relative; transform: translateX(-13px)" 
            :style="`left:${getPercentage(scoreProfile?.highestScore, scoreProfile?.maximumMarks)}%`">
                <img
                :src="highestScoreImage"
                alt="pass icon"
                style="width:26px; height:24px;"
                />
                <div style="font-size: 12px;">
                  {{scoreProfile?.highestScore}}
                </div>
              </div>
          </div>
        </div>
        
        <div style="display: flex; justify-content: center; align-items: center; gap:16px;">
          <div style="display: flex; align-items:center">
            <img
              :src="highestScoreImage"
              alt="pass icon"
              style="width:26px; height:24px; margin-right:16px"
            />
            <div style="font-size: 14px;">Highest Score</div>
          </div>
          <div style="display: flex; align-items:center">
            <img
            :src="yourScoreImage"
            alt="pass icon"
            style="width:26px; height:24px; margin-right:16px"
            />
            <div style="font-size: 14px;">Your Score</div>
          </div>
        </div>
      </div>
      <div style="width:100%  !important; display: flex; font-size:14px; height:300px; border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F; padding:16px;">
        <div style="flex: 1; display:flex; flex-direction:column; justify-content:space-between; height:260px">
          <div>
            <div style="font-size: 18px; font-weight: 600;">Assessment completion time</div>
            <div style="
            font-size: 12px;
            font-weight: 400; ; 
            padding-bottom: 8px;
            color:#666666">
              Indicates your completion time Vs average time
            </div>
          </div>
          <div style="display:flex; flex-direction:column; gap:12px">
            <div style="display:flex; gap:8px;">
              <div style="background-color:#FFB86B; height:16px; width:24px; border-radius:4px;"></div>
              <div>Average Time Taken (in mins)</div>
            </div>
            <div style="display:flex; gap:8px;">
              <div style="background-color:#06C270; height:16px; width:24px; border-radius:4px;"></div>
              <div>Your Time Taken (in mins)</div>
            </div>
          </div>
        </div>
        <div style="flex: 1; display: flex; gap:24px; justify-content: end; padding-right:32px">
          <div style="display: flex; gap:24px; justify-content: end;">
            <div style="width:40px; height: 260px; background-color: #E0E0E0; border-radius:20px;
            display:flex; flex-direction:column; align-items:center; justify-content:end;">
              <div style="position:relative; background-color: #FFB86B;
              border-radius: 0px 0px 20px 20px;"
              :style="`height:${calculatePosition(scoreProfile?.averageTimeTaken, scoreProfile?.maximumTime/60)}%`">
              <div style="
              position:relative;
              top: -25px;
              display:flex;
              justify-content: center;
              align-items: center;
              height:40px; width:40px; 
              border-radius:20px; 
              border: 2px solid #C37C2F; background-color:#FFD4B2;">{{ scoreProfile?.averageTimeTaken }}</div>
              </div>
            </div>
          </div>
          <div style="width:40px; height: 260px; background-color: #E0E0E0; border-radius:20px;
          display:flex; flex-direction:column; align-items:center; justify-content:end;">
            <div style="position:relative; background-color: #06C270;
            border-radius: 0px 0px 20px 20px;"
            :style="`height:${calculatePosition(scoreProfile?.userTimeTaken, scoreProfile?.maximumTime/60)}%;`">
              <div style="
              position:relative;
              top: -25px;
              display:flex;
              justify-content: center;
              align-items: center;
              height:40px; width:40px; 
              border-radius:20px;
              border: 2px solid #00A755; 
              background-color:#6FD3A6;">
                {{ scoreProfile?.userTimeTaken }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="width:100%  !important; display: flex;justify-content: space-between; align-items: center; 
        border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F;border-bottom: 2px solid rgba(0, 0, 0, 0.18); 
        margin:16px; margin-top:200px; padding:16px;">
          <div style="position: relative; transform: rotate(180deg); bottom:36px; height:20px; width:22.49px;">
            <img src="../../src/assets/userPerformanceQuote2.svg" alt="">
          </div>
          <div style="display: flex; flex-direction:column; gap:4px;">
            <p style="font-size: 16px; color: #666666; font-weight: 600;">
              Education is the most powerful weapon which you can use to change the world.
            </p>
            <div style="font-size: 14px; margin-left:auto; font-weight:500; color:#B68C00;">— Pele</div>
          </div>
          <div style="position: relative; top: 36px; height:20px; width:22.49px;">
            <img src="../../src/assets/userPerformanceQuote2.svg" alt="">
          </div>
      </div>
    </div>
    <div ref="userPerformanceReport3" class="user-performance-report" style="width:700px; display: flex; flex-direction:column; justify-content:space-between; padding:16px;gap: 16px;">
        <div style="width:100%; display: flex; flex-direction:column;
        border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F;border-bottom: 2px solid rgba(0, 0, 0, 0.18); 
        padding:16px;">
          <div>
            <div style="font-size: 18px; font-weight: 600;">Skill-wise Score Distribution <span v-if="isGtoReport">(In Percentage)</span></div>
          </div>
          <div style="display:flex; justify-content:center; align-items:center;">
            <VueApexCharts
            type="radar"
            :options="scoreDistributionChartOptions"
            :series="scoreDistributionChartData"
            :height="500"
            :width="600"
            />
          </div>
          <div style="display:flex; justify-content:center; align-items: center;">
            <div style="display:flex; flex-direction:row; gap:8px">
              <div style="display:flex; flex-direction:column; justify-content:center;">
                <div style="background-color: #06C27099; width:24px; height: 16px; border-radius: 4px;"></div>
              </div>
              <div>Achieved</div>
            </div>
          </div>
        </div>
      <div style="width:100%; display: flex; flex-direction:row; 
      justify-content: space-between; align-items: center; 
      border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F;border-bottom: 2px solid rgba(0, 0, 0, 0.18); 
      margin:16px; margin-top:100px; padding:16px;">
        <div style="position: relative; transform: rotate(180deg); bottom:36px; height:20px; width:22.49px;">
          <img src="../../src/assets/userPerformanceQuote1.svg" alt="">
        </div>
        <div style="display: flex; flex-direction:column; gap:4px">
          <p style="font-size: 16px; font-weight: 600; color: #666666;">
            Success is no accident. It is hard work, perseverance, learning, studying, and sacrifice.
          </p>
          <div style="margin-left:auto; font-weight:500; color:#5F347B;">— Nelson Mandela</div>
        </div>
        <div style="position: relative; top: 36px; height:20px; width:22.49px;">
          <img src="../../src/assets/userPerformanceQuote1.svg" alt="">
        </div>
      </div>
    </div>
    <div v-for="(skill,index) in skillsAnalysisForAdvanceReport" :key="`userPerformanceReport-skillsAnalysis-${index}`" 
    :data-section-title="getDataSectionTitle(skill, index)"
    :aria-label="`skills-${Array.isArray(skill)?  'StrandAnalysis' : skill.skillName}`" 
    style="display: flex; flex-direction:column; 
    margin:0px 16px; padding:8px 0px; gap:16px" class='user-performance-report'>
      <!-- Skills Title Card Page -->
      <!-- <div v-if="skill.isTitleCard" style="height:100%; display:flex; flex-direction: column; align-items: end;"> -->
      <div v-if="skill.isTitleCard" style="position: absolute; height: 85%; display:flex; flex-direction: column; left: 0;">
        <img :src="skillTitleCardBackgroundImage" style="top: 0; left: 0; width: 100%; height: 100%;"/>
        <div style="position: absolute; z-index: 1000;  display: flex; align-items:center; justify-content:end; margin-right: 16px; height: 100%; width: 100%">
          <div style="width:392px; min-height: 248px; display:flex; flex-direction:column; align-items:center; justify-content:center; text-align: center;
          padding: 20px; border-radius:8px;"
            :style="[skill.backgroundColor, skill.borderGradient]">
            <div style="font-size: 24px; font-weight: 600; color: #212121; margin-bottom: 24px;">{{ skill.skillName }}</div>
            <div style="
            word-wrap: break-word;            
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            letter-spacing: 0.0025em;
            text-underline-position: from-font;
            text-decoration-skip-ink: none;
            color: #666666;">{{ skill.text }} </div>
          </div>
        </div>
        
      </div>
      <!-- Skills/Subjects Template -->
      <div v-else-if="(skill?.skillName !== 'Psychometry' || isLeadershipReport) && !Array.isArray(skill)"
      style="width: 700px !important; padding: 16px; border-radius: 8px !important;
      box-shadow: 0px 2px 10px 0px #0000001F;border-bottom: 2px solid rgba(0, 0, 0, 0.18);" >
        <div v-if="skill.isFirstSkillsPage">
          <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; margin-bottom: 16px;">
            <div style="font-size:16px; font-weight:600;">{{ isFocusedReport ? "Overall Report" : getSkillAlias(skill.skillName)  }}</div>
          </div>
          <div v-if="skill?.isCoreSkill && !isGtoReport" style="display: flex; padding: 8px; background: #1B72E81F; box-shadow: 0px 2px 10px 0px #0000001F; border-bottom: 2px solid rgba(0, 0, 0, 0.18); border-radius: 8px; margin-bottom: 16px;">
            <div style="display:flex; justify-content: space-between; flex: 1; padding: 8px 16px; border-right: 0.75px solid #CBCBCB">
              <span>Rank</span>
              <div style="display: flex; gap: 32px;">
                <span> - </span>
                <span> {{ skill?.rank == 'Not Eligible' ? skill?.rank : `#${skill?.rank}` }} </span>
              </div>
            </div>
            <div style="display:flex; justify-content: space-between; flex: 1;  padding: 8px 16px;">
              <span>League</span>
              <div style="display: flex; gap: 32px;">
                <span> - </span>
                  <div style="display: flex; flex-direction: row;">
                    <img v-if="['gold','silver', 'bronze', 'bonze'].includes(skill?.league?.toLowerCase())"
                    style="height:16px; width:20px; margin-right:8px;"
                    :src="getLeagueIcon(skill?.league)"/>
                    <div>
                      {{ skill?.league }}
                    </div>
                  </div>
              </div>
            </div>
          </div>
          <div style="display: flex; padding: 8px; background: #B27CC433; box-shadow: 0px 2px 10px 0px #0000001F; border-bottom: 2px solid rgba(0, 0, 0, 0.18); border-radius: 8px; margin-bottom: 16px;">
            <div style="display:flex; justify-content: space-between; flex: 1; padding: 8px 16px; border-right: 0.75px solid #CBCBCB">
              <span>Total Questions</span>
              <div style="display: flex; width: 20%; gap: 32px;">
                <span> - </span>
                <span> {{ skill?.questionCounts?.total }} </span>
              </div>
            </div>
            <div style="display:flex; justify-content: space-between; flex: 1; padding: 8px 16px;">
              <span>Questions Attempted</span>
              <div style="display: flex; width: 20%; gap: 32px;">
                <span> - </span>
                <span> {{ (skill?.questionCounts?.correct + skill?.questionCounts?.incorrect) }} </span>
              </div>
            </div>
          </div>
          <div style="display: flex; padding: 8px; background: #06C27024; box-shadow: 0px 2px 10px 0px #0000001F; border-bottom: 2px solid rgba(0, 0, 0, 0.18); border-radius: 8px; margin-bottom: 16px;">
            <div style="display:flex; justify-content: space-between; flex: 1; padding: 8px 16px; border-right: 0.75px solid #CBCBCB">
              <span>Correct Answers</span>
              <div style="display: flex; width: 20%; gap: 32px;">
                <span> - </span>
                <span> {{ skill?.questionCounts?.correct }} </span>
              </div>
            </div>
            <div style="display:flex; justify-content: space-between; flex: 1; padding: 8px 16px;">
              <span>Incorrect Answers</span>
              <div style="display: flex; width: 20%; gap: 32px;">
                <span> - </span>
                <span> {{ skill?.questionCounts?.incorrect }} </span>
              </div>
            </div>
          </div>
          <div style="width:672px; display: flex; flex-direction:column; 
          border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F;border-bottom: 2px solid rgba(0, 0, 0, 0.18); 
          padding:8px;">
            <div style="color: #212121; font-size:14px; font-weight:600; margin-bottom: 8px;">Strengths, Competency Areas & Areas for Improvement</div>
            <div style="color: #666666; font-size:10px; font-weight:400;">Displays key strengths, competency areas, and areas for improvement based on the assessment results.</div>
            <div style="display:flex; justify-content:center; align-items:center; width:100%">
              <VueApexCharts
              type="donut"
              :options="donutChartOptions"
              :series="[skill?.totalStrengths, skill?.totalCompetentAreas, skill?.totalWeaknesses]" 
              :height="500"
              :width="500"
              />
            </div>
          </div>
        </div>
        <div style="display: flex; flex-direction: column; gap: 8px; margin-top: 16px">
          <div v-if="skill?.strengths?.length > 0" style="font-weight:600; font-size:18px; color: #212121;">
            Strengths
          </div>
          <div v-if="skill?.strengths?.length > 0" style="display: flex; flex-direction: column; margin-bottom: 16px; gap: 8px;">
            <div v-for="(topic, index) in skill?.strengths" :key="`strengths-${index}`" style="width: 100%; height:36px; display: flex;  border-radius: 15px; background-color: #06C27023;">
              <div style="display: grid; place-items: center;  background-color:#06C2704C; width:36px; height:36px; flex-shrink:0; border-radius:18px; border: 0.75px solid #007C2A; font-weight:350 !important; font-size:10px;">
                {{ skill?.strengthsInLastPages + index + 1}}
              </div>
              <div style="display: flex; justify-content:center; align-items:center; margin:4px 36px 4px 8px; font-weight:400; font-size:12px;">
                {{topic}}
              </div>
            </div>
          </div>

          <div v-if="skill?.competentAreas?.length > 0" style="font-weight:600; font-size:18px; color: #212121;">
            Competency Areas
          </div>
          <div v-if="skill?.competentAreas?.length > 0" style="display: flex; flex-direction: column; margin-bottom: 16px; gap: 8px;">
            <div v-for="(topic, index) in skill?.competentAreas" :key="`competentAreas-${index}`" style="width: 100%; height:36px; display: flex;  border-radius: 15px; background-color: #4592FF24;">
              <div style="display: grid; place-items: center;  background-color:#4592FF4D; width:36px; height:36px; flex-shrink:0; border-radius:18px; border: 0.75px solid #4592FF; font-weight:350 !important; font-size:10px;">
                {{ skill?.competentAreasInLastPages + index + 1}}
              </div>
              <div style="display: flex; justify-content:center; align-items:center; margin:4px 36px 4px 8px; font-weight:400; font-size:12px;">
                {{topic}}
              </div>
            </div>
          </div>

          <div v-if="skill?.weaknesses?.length > 0" style="font-weight:600; font-size:18px; color: #212121;">
            Areas for Improvement
          </div>
          <div v-if="skill?.weaknesses?.length > 0" style="display: flex; flex-direction: column; margin-bottom: 16px; gap: 8px;">
            <div v-for="(topic, index) in skill?.weaknesses" :key="`weaknesses-${index}`" style="width: 100%; height:36px; display: flex; border-radius: 15px; background-color: #F77CAE23;">
              <div style="display: grid; place-items: center;  background-color:#F77CAE4C; width:36px; height:36px; flex-shrink:0; border-radius:18px; border: 0.75px solid #C54A7C; font-weight:400; font-size:10px;">
                {{ skill?.weaknessesInLastPages + index + 1 }}
              </div>
              <div style="display: flex; justify-content:center; align-items:center; margin:4px 36px 4px 8px; font-weight:350!important; font-size:12px;">
                {{topic}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Psychometry Template -->
      <div v-else-if="skill?.skillName == 'Psychometry' && !isLeadershipReport" style="width: 700px !important; display: flex; flex-direction:column;
      border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F;border-bottom: 2px solid rgba(0, 0, 0, 0.18);
      padding:16px; gap:16px">
        <div v-if="skill.isFirstSkillsPage" style="display: flex; gap: 40px; padding: 16px; background: #B27CC433; box-shadow: 0px 2px 10px 0px #0000001F; border-bottom: 2px solid rgba(0, 0, 0, 0.18); border-radius: 8px; margin-bottom: 16px;">
          <div style="display:flex; justify-content: space-between; flex: 1">
            <span>Total Questions</span>
            <div style="display: flex; gap: 20px;">
              <span> - </span>
              <span> {{ skill?.questionCounts?.total }} </span>
            </div>
          </div>
          <div style="display:flex; justify-content: space-between; flex: 1">
            <span>Questions Attempted</span>
            <div style="display: flex; gap: 20px;">
              <span> - </span>
              <span> {{ (skill?.questionCounts?.correct + skill?.questionCounts?.incorrect) }} </span>
            </div>
          </div>
        </div>
        <div v-if="skill.isFirstSkillsPage" style="margin: 0px 8px 16px 0px;">
          <div style="color:#212121; font-weight:600; margin-bottom:12px;">Legend</div>
          <div style="margin-bottom: 16px;">The given rating is out of 4</div>
          <div style="display: flex; margin-bottom: 8px;">
            <div style="display: flex; justify-content: start; gap:16px; width:50%;">
              <div style="width: 20px; height:20px; border-radius: 10px; font-size: 12px;" :style="selectBackgroundColor(4, true)"></div>
              <div>Highly recommended</div>
            </div>
            <div style="display: flex; justify-content: start; gap:16px; width:50%;">
              <div style="width: 20px; height:20px; border-radius: 10px; font-size: 12px;" :style="selectBackgroundColor(3, true)"></div>
              <div>Recommended</div>
            </div>
          </div>
          <div style="display: flex; margin-bottom: 8px;">
            <div style="display: flex; justify-content: start; gap:16px; width:50%;">
              <div style="width: 20px; height:20px; border-radius: 10px; font-size: 12px;" :style="selectBackgroundColor(2, true)"></div>
              <div>Development needed</div>
            </div>
            <div style="display: flex; justify-content: start; gap:16px; width:50%;">
              <div style="width: 20px; height:20px; border-radius: 10px; font-size: 12px;" :style="selectBackgroundColor(1, true)"></div>
              <div>Not recommended at this time</div>
            </div>
          </div>
        </div>
        <div v-for="(strandData, strandName, index) in skill?.psychometryAnalysis?.strands" :key="`strands-${index}`"
        style="display:flex; flex-direction:column; gap:16px; border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F;border-bottom: 2px solid rgba(0, 0, 0, 0.18); padding:8px; margin-top: 8px"
        > 
          <div style="font-weight:600; padding:8px">{{ strandName }}</div>
          <div style="display: flex; flex-wrap: wrap;">
            <div v-for="(subStrand, index) in strandData.subStrands" :key="index"
              style="display:flex;
              height: 32px;
              justify-content:center;
              align-items:center;
              height:32px;
              border-radius:16px; 
              background-color:#E1E8F5;
              color:#3F41D1;
              padding: 0px 16px;
              margin: 4px;
              margin-left:8px;
              font-size:12px;
              font-weight:400;" >
                {{subStrand}}
              </div>
          </div>
          <div style="display: flex; justify-content:space-between">
            <div style="font-weight:600; padding:8px">Rating and Feedback</div>
            <div style="height:32px; width:56px; border-radius:28px; display:grid; place-items: center" :style="selectBackgroundColor(strandData?.normalizedScore, true)">{{ strandData.normalizedScore }}</div>
          </div>
          <div style="border-radius: 8px; padding:16px;" :style="selectBackgroundColor(strandData?.normalizedScore, false)">
            {{ strandData?.feedback }}
          </div>
        </div>
      </div>
      <!-- Strand Analysis Template (Focused Report) -->
      <div v-else-if="isFocusedReport && Array.isArray(skill)">
        <div v-for="(strand, index) in skill" :key="`strand-${index}`" style="width: 700px !important; padding: 16px; border-radius: 8px !important;
        box-shadow: 0px 2px 10px 0px #0000001F;border-bottom: 2px solid rgba(0, 0, 0, 0.18); margin: 16px 0px">
          <div v-if="!strand?.isStrand">
            <div v-if="strand?.skillName" style="font-size:16px; font-weight:600; margin-bottom: 16px;">{{ strand.skillName   }}</div>
            <div v-if="strand?.skillDefinition" style="font-weight: 350; font-size: 12px;">{{ strand.skillDefinition }}</div>
          </div>

          <div v-else-if="strand?.isStrand">
            <div v-if="strand?.strandName" style="font-size:16px; font-weight:600; margin-bottom: 16px;">{{ strand.strandName  }}</div>
            <div v-if="strand?.strandDefinition" style="font-weight: 350; font-size: 12px;">{{ strand.strandDefinition }}</div>

            <div v-if="strand?.questionCounts" style="display: flex; gap: 40px; padding: 16px; background: #B27CC433; box-shadow: 0px 2px 10px 0px #0000001F; border-bottom: 2px solid rgba(0, 0, 0, 0.18); border-radius: 8px; margin: 16px 0px;">
              <div style="display:flex; justify-content: space-between; flex: 1">
                <span>Total Questions</span>
                <div style="display: flex; gap: 20px;">
                  <span> - </span>
                  <span> {{ strand?.questionCounts?.total }} </span>
                </div>
              </div>
              <div style="display:flex; justify-content: space-between; flex: 1">
                <span>Questions Attempted</span>
                <div style="display: flex; gap: 20px;">
                  <span> - </span>
                  <span> {{ (strand?.questionCounts?.correct + strand?.questionCounts?.incorrect) }} </span>
                </div>
              </div>
            </div>

            <div v-if="strand?.questionCounts" style="display: flex; gap: 40px; padding: 16px; background: #06C27024; box-shadow: 0px 2px 10px 0px #0000001F; border-bottom: 2px solid rgba(0, 0, 0, 0.18); border-radius: 8px; margin: 16px 0px;">
              <div style="display:flex; justify-content: space-between; flex: 1">
                <span>Correct Answers</span>
                <div style="display: flex; gap: 20px;">
                  <span> - </span>
                  <span> {{ strand?.questionCounts?.correct }} </span>
                </div>
              </div>
              <div style="display:flex; justify-content: space-between; flex: 1">
                <span>Incorrect Answers</span>
                <div style="display: flex; gap: 20px;">
                  <span> - </span>
                  <span> {{ strand?.questionCounts?.incorrect }} </span>
                </div>
              </div>
            </div>

            <div v-if="strand?.chartData" style="width:672px;  margin: 16px 0px; display: flex; flex-direction:column; 
            border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F;border-bottom: 2px solid rgba(0, 0, 0, 0.18); 
            padding:8px;">
              <div style="color: #212121; font-size:14px; font-weight:600; margin-bottom: 8px;">Strengths, Competency Areas & Areas for Improvement</div>
              <div style="color: #666666; font-size:10px; font-weight:400;">Displays key strengths, competency areas, and areas for improvement based on the assessment results.</div>
              <div style="display:flex; justify-content:center; align-items:center; width:100%">
                <VueApexCharts
                type="donut"
                :options="donutChartOptions"
                :series="strand.chartData" 
                :height="500"
                :width="500"
                />
              </div>
            </div>

            <div v-if="strand?.strengths || strand?.weaknesses" style="display: flex; flex-direction: column; gap: 16px;">
              <div v-if="strand?.strengths?.length > 0" style="font-weight:600; font-size:18px; color: #212121;">
                Strengths
              </div>
              <div v-if="strand?.strengths?.length > 0" style="display: flex; flex-direction: column; gap: 8px;">
                <div v-for="(topic, index) in strand?.strengths" :key="`strengths-${index}`" style="width: 100%; height:36px; display: flex;  border-radius: 15px; background-color: #06C27023;">
                  <div style="display: grid; place-items: center;  background-color:#06C2704C; width:36px; height:36px; flex-shrink:0; border-radius:18px; border: 0.75px solid #007C2A; font-weight:350 !important; font-size:10px;">
                    {{  ( strand?.strenghtsInLastPage || 0 ) + index + 1 }}
                  </div>
                  <div style="display: flex; justify-content:center; align-items:center; margin:4px 36px 4px 8px; font-weight:400; font-size:12px;">
                    {{topic}}
                  </div>
                </div>
              </div>

              <div v-if="strand?.competentAreas?.length > 0" style="font-weight:600; font-size:18px; color: #212121;">
                Competency Areas
              </div>
              <div v-if="strand?.competentAreas?.length > 0" style="display: flex; flex-direction: column; gap: 8px;">
                <div v-for="(topic, index) in strand?.competentAreas" :key="`competentAreas-${index}`" style="width: 100%; height:36px; display: flex;  border-radius: 15px; background-color: #4592FF24;">
                  <div style="display: grid; place-items: center;  background-color:#4592FF4D; width:36px; height:36px; flex-shrink:0; border-radius:18px; border: 0.75px solid #4592FF; font-weight:350 !important; font-size:10px;">
                    {{  ( strand?.competentAreasInLastPages || 0 ) + index + 1 }}
                  </div>
                  <div style="display: flex; justify-content:center; align-items:center; margin:4px 36px 4px 8px; font-weight:400; font-size:12px;">
                    {{topic}}
                  </div>
                </div>
              </div>

              <div v-if="strand?.weaknesses?.length > 0" style="font-weight:600; font-size:18px; color: #212121;">
                Areas for Improvement
              </div>
              <div v-if="strand?.weaknesses?.length > 0" style="display: flex; flex-direction: column; gap: 8px;">
                <div v-for="(topic, index) in strand?.weaknesses" :key="`weaknesses-${index}`" style="width: 100%; height:36px; display: flex; border-radius: 15px; background-color: #F77CAE23;">
                  <div style="display: grid; place-items: center;  background-color:#F77CAE4C; width:36px; height:36px; flex-shrink:0; border-radius:18px; border: 0.75px solid #C54A7C; font-weight:400; font-size:10px;">
                    {{ ( strand?.weaknessesInLastPage || 0 ) + index + 1 }}
                  </div>
                  <div style="display: flex; justify-content:center; align-items:center; margin:4px 36px 4px 8px; font-weight:350!important; font-size:12px;">
                    {{topic}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- Recommendation Links template -->
   <section v-if="recommendationLinks?.length > 0">
    <div data-section-title="recommendationLinks" v-for="(page, pageIndex) in recommendationLinks" :ref="`recommendationLinksTemplate-${pageIndex}`" :key="pageIndex">
      <div style="display:flex; flex-direction:column; gap:16px; font-size:20px; font-weight:600; margin:0px 16px">
        <div v-if="pageIndex == 0">Recommendations For you</div>
        <div v-for="(skill, key) in page" :key="key" 
        style="display: flex; flex-direction: column; gap:12px; padding:16px;
        border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F; 
        border-bottom: 2px solid rgba(0, 0, 0, 0.18);">

          <div v-if="!skill?.isSkillContinued && (skill.recommendedReadings.videos?.length > 0 || skill.recommendedReadings.referenceDocs?.length > 0)" style="border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F; 
          border-bottom: 2px solid rgba(0, 0, 0, 0.18); display:flex; align-items:center;
          height:36px; padding: 4px 12px; font-size: 14px; font-weight:600"
          :style="skill.backgroundColor">
            {{ getSkillAlias(skill.skillName) }}
          </div>

          <div v-if="skill.recommendedReadings.videos?.length > 0" style="display: contents;">

            <div  style="padding-left:12px; font-size: 12px; font-weight:600">
              Videos
            </div>
            <div v-for="(video, videoIndex) in skill.recommendedReadings.videos" :key="`videos-${videoIndex}`"
            style="width: 100%; padding-left: 12px; font-size: 12px; font-weight: 400; word-wrap: break-word; overflow-wrap: break-word; white-space: normal;">
              <a style="font-weight: 400; color:#0A67C4" target="_blank" :href="encodeUnderscores(video.url)">{{ video.title }}</a>
            </div>
          </div>

          <div v-if="skill.recommendedReadings.referenceDocs?.length > 0" style="display:contents;">

            <div  style="padding-left:12px; font-size: 12px; font-weight:600">
              Reference Documents
            </div>

            <div v-for="(doc, docIndex) in skill.recommendedReadings.referenceDocs" :key="`videos-${docIndex}`"
            style="width: 100%; padding-left: 12px; font-size: 12px; font-weight: 400; word-wrap: break-word; overflow-wrap: break-word; white-space: normal;">
              <a style="font-weight: 400; color:#0A67C4" target="_blank" :href="doc.url">{{ doc.title }}</a>
            </div>

          </div>
        </div>
      </div>
    </div>
   </section>

    <!-- BASIC REPORT TEMPLATES -->
     <!-- basic report Index -->
     <div ref="basicReportIndex" style="display:flex; flex-direction:column; padding: 0px 10px; gap: 24px;">
      <div style="display:flex; justify-content:center; font-size:20px; font-weight:550">Index</div>
      <!-- Section -->
      <div style="display:flex; flex-direction: column;
      box-shadow: 0px 2px 10px 0px #0000001F; 
      padding:24px; border-radius: 8px !important; gap:24px;">
        <div style="display:flex; flex-direction: column; margin-bottom: 16px;">
          <div style="display:flex;">
            <span  style="font-size:16px;">1. Understanding your report</span>
            <span :style="getDottedSeparator(16)"></span>
            <span>01</span>
          </div>
        </div>
        <!-- Section -->
        <div style="display:flex; flex-direction: column; margin-bottom: 16px; gap:16px">
          <div style="display:flex;">
            <span style="font-size:16px;">2. Performance at Glance</span>
            <span :style="getDottedSeparator(16)"></span>
            <span>02</span>
          </div>
          <!-- Sub-sections -->
          <div style="display:flex; flex-direction: column; gap:16px; padding-left:30px">
            <div style="display:flex; margin-bottom:4px">
              <span style="font-size:14px;">2.1. Assessment Analysis</span>
              <span :style="getDottedSeparator(14)"></span>
              <span>02</span>
            </div>
            <div style="display:flex; margin-bottom:4px">
              <span style="font-size:14px;"> 2.2. Assessment completion time</span>
              <span :style="getDottedSeparator(14)"></span>
              <span>03</span>
            </div>
            <div style="display:flex; margin-bottom:4px">
              <span style="font-size:14px;">2.3. Skill-wise Score Distribution</span>
              <span :style="getDottedSeparator(14)"></span>
              <span>03</span>
            </div>
          </div>
        </div>

         <!-- Section -->
         <div style="display:flex; flex-direction: column; gap:16px">
          <div style="display:flex;">
            <span style="font-size:16px;">3. Detailed Report</span>
            <span :style="getDottedSeparator(14)"></span>
            <span>04</span>
          </div>
          <!-- Sub-sections --> 
          <div style="display:flex; flex-direction: column; gap:16px; padding-left:30px">
            <div v-for="(skill, index) in basicReportSkillsSections" :key="`index-skillsSections-${index}`" style="display:flex; flex-direction:column; gap:16px; width:100%;">
              <div style="display:flex;">
                <span style="font-size:14px;"> {{` 3.${index+1} ${skill.skillName}`}}</span>
                <span :style="getDottedSeparator(14)"></span>
                <span>{{ padWithZero(skill.pageNumber) }}</span>
              </div>
              <div style="display:flex; flex-direction:column; gap:16px;  padding-left:30px;" v-if="skill.skillName == 'Core Skills'">
                <div v-for="(subject, i) in basicReportSubjectsSubSection" 
                :key="`index-subjectsSubSection-${i}`" style="display:flex; width:100%;">
                <span style="font-size:12px;"> {{` 3.1.${i+1} ${subject.skillName}`}}</span>
                <span :style="getDottedSeparator(12)"></span>
                <span>{{ padWithZero(subject.pageNumber) }}</span>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
     <!-- BasicReportTemplate -->
     <div ref="basicReportTemplate1" 
     style="display: flex; 
     flex-direction:column;
     padding:0 16px;
     gap: 16px;
     ">
       <div style="display: flex; flex-direction:row; flex-grow: 1; align-items: stretch; justify-content: center; width:100%; gap: 16px; margin-bottom: 26px;">
         <div style="width:100%; display: flex; border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F; padding:14px;">
          <img v-if="userInfo?.proctoringPic" style="height: 70px; width: 70px; border-radius: 35px;" :src="userInfo?.proctoringPic" alt="">
          <img v-else style="height: 70px; width: 70px; border-radius: 35px; " :src="userAvatarPlaceholder"/>
           <div style="display:flex; flex-direction:column; justify-content: space-evenly; margin-left:16px;">
             <div style="font-size:16px; font-weight:400;">{{ userInfo?.name }}</div>
           </div>
         </div>
         <div style="
         width:100%;
         font-size:14px;
         font-weight:400;
         display:flex;
         flex-direction:column;
         justify-content: space-evenly;
         border-radius: 8px !important; 
         box-shadow: 0px 2px 10px 0px #0000001F;
         padding:14px">
           <div>
               Email -  {{ userInfo?.email }}
           </div>
           <div>
               Mobile - {{ userInfo?.phone }}
           </div>
         </div>
       </div>
       <div style="display:flex; flex-direction:column; border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F; padding:16px; gap:8px; margin-bottom: 16px;">
         <div style="display:flex; flex-direction:row; align-items:center;">
           <div style="width:25%; font-size:16px; font-weight:400;">Level</div>
           <div style="margin-right:16px;">-</div>
           <div style="width:70%; display:flex; flex-direction:row; align-items:center;">
             <div v-for="(level, index) in userInfo?.levels" :key="`userPerformanceReport1-levels-${index}`"
               style="
                height: 32px;
                display:flex;
                justify-content:center;
                align-items:center;
                border: 0.5px solid #3F41D1; 
                border-radius:16px; 
                background-color:#E1E8F5;
                color:#3F41D1;
                padding: 0px 16px;
                font-size:12px;
                font-weight:400;">
                 {{  level }}
             </div>
           </div>
         </div>
         <div style="display:flex; flex-direction:row; align-items:center;">   
           <div style="width:25%; font-size:16px; font-weight:400;">Subjects/Skills</div>
           <div style="margin-right:16px;">-</div>
           <div style="max-width:70%; display: flex; flex-wrap: wrap;">
             <div v-for="(subject, index) in userInfo.skillsToShow" :key="`userPerformanceReport1-skillsToShow-${index}`"
             style="
              height: 32px;
              display:flex;
              justify-content:center;
              align-items:center;
              border: 0.5px solid #3F41D1; 
              border-radius:16px; 
              background-color:#E1E8F5;
              color:#3F41D1;
              padding: 0px 16px;
              margin: 0px 8px 8px 0px;
              font-size:12px;
              font-weight:400;">
               {{ subject }}
             </div>
           </div>
         </div>
       </div>
       <div style="margin-bottom: 16px;">
         <div style="font-size:24px; font-weight: 600; margin-bottom: 26px;">Performance at a Glance</div>
         <div style="display:flex; flex-direction:column; border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F; padding:16px; gap:8px;">
           <div style="font-size: 18px; font-weight: 600;">Assessment Analysis</div>
           <div style="position: relative; display:flex; justify-content:center; align-items:center;">
             <!-- Radial Bar Chart -->
             <VueApexCharts
               type="radialBar"
               :options="overallAssessmentChartOptions"
               :series="overallAssessmentChartData"
               :width="600"
               :height="600"
             />
         
             <!-- Overlay Labels -->
             <div
               v-for="(value, index) in overallAssessmentChartData"
               :key="`userPerformanceReport1-overallAssessmentChartData-${index}`"
               :style="getLabelStyle(index)"
               style="pointer-events: none;"
             >
               {{ value }}%
             </div>
           </div>
         </div>
       </div>
     </div>
      <div ref="basicReportTemplate2" style="width: 734px; padding:10px 10px; display:flex; flex-direction:column; gap:16px;">
        <div style="font-size:14px; width:100%; display: flex; border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F; padding:16px;">
          <div style="flex: 1; display:flex; flex-direction:column; justify-content:space-between; height:260px">
            <div>
              <div style="font-size: 18px; font-weight: 600;">Assessment completion time</div>
              <div style="
              font-size: 12px;
              font-weight: 400; ; 
              padding-bottom: 8px;
              color:#666666">
                Indicates your completion time vs average time
              </div>
            </div>
            <div style="display:flex; flex-direction:column; gap:12px">
              <div style="display:flex; gap:8px;">
                <div style="background-color:#FFB86B; height:16px; width:24px; border-radius:4px;"></div>
                <div>Average Time Taken (in mins)</div>
              </div>
              <div style="display:flex; gap:8px;">
                <div style="background-color:#06C270; height:16px; width:24px; border-radius:4px;"></div>
                <div>Your Time Taken (in mins)</div>
              </div>
            </div>
          </div>
          <div style="flex: 1; display: flex; gap:24px; justify-content: end; padding-right:32px">
            <div style="display: flex; gap:24px; justify-content: end;">
              <div style="width:40px; height: 260px; background-color: #E0E0E0; border-radius:20px;
              display:flex; flex-direction:column; align-items:center; justify-content:end;">
                <div style="position:relative; background-color: #FFB86B;
                border-radius: 0px 0px 20px 20px;"
                :style="`height:${calculatePosition(scoreProfile?.averageTimeTaken, scoreProfile?.maximumTime/60)}%`">
                <div style="
                position:relative;
                top: -25px;
                display:flex;
                justify-content: center;
                align-items: center;
                height:40px; width:40px; 
                border-radius:20px; 
                border: 2px solid #C37C2F; background-color:#FFD4B2;">{{ scoreProfile?.averageTimeTaken }}</div>
                </div>
              </div>
            </div>
            <div style="width:40px; height: 260px; background-color: #E0E0E0; border-radius:20px;
            display:flex; flex-direction:column; align-items:center; justify-content:end;">
              <div style="position:relative; background-color: #06C270;
              border-radius: 0px 0px 20px 20px;"
              :style="`height:${calculatePosition(scoreProfile?.userTimeTaken, scoreProfile?.maximumTime/60)}%;`">
                <div style="
                position:relative;
                top: -25px;
                display:flex;
                justify-content: center;
                align-items: center;
                height:40px; width:40px; 
                border-radius:20px;
                border: 2px solid #00A755; 
                background-color:#6FD3A6;">
                  {{ scoreProfile?.userTimeTaken }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width:100%; display: flex; flex-direction:column;
        border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F;border-bottom: 2px solid rgba(0, 0, 0, 0.18); 
        padding:16px;">
          <div style="display:flex; justify-content:center; align-items:center;">
            <VueApexCharts
            type="radar"
            :options="scoreDistributionChartOptions"
            :series="scoreDistributionChartData"
            :height="500"
            :width="600"
            />
          </div>
          <div style="display:flex; justify-content:center; align-items: center;">
            <div style="display:flex; flex-direction:row; gap:8px">
              <div style="display:flex; flex-direction:column; justify-content:center;">
                <div style="background-color: #06C27099; width:24px; height: 16px; border-radius: 4px;"></div>
              </div>
              <div>Achieved</div>
            </div>
          </div>
        </div>
      </div>
    <!-- basicReportSkillsTemplate -->
    <div v-for="(skillBin, index) in skillsAnalysisForBasicReport" style="padding: 0px 10px" :key="`skillBin-${index}`" :ref="`basicReportSkillsTemplate-${index}`">
      <div v-for="(binItem, index) in skillBin" :key="`binItem-${index}`" 
      :data-section-title="`${binItem.isCoreSkill ? 'Subject-': ''}${binItem.skillName}`">
        <div v-if="binItem?.isTitleCard" style="display: grid; grid-template-columns: repeat(12, 1fr);
         gap: 16px; width: 100%; margin-bottom: 20px;">
          <div style="grid-column: span 3; 
          padding: 30px; display: flex; border-radius:8px;
          align-items: center; justify-content: center;"
          :style="[binItem.backgroundColor, binItem.borderGradient]">
            <span style="color: black; font-size: 16px; font-weight: 600; text-align:center;">
              {{ binItem?.isCoreSkill ? 'Core Skills' :binItem?.skillName }}
            </span>
          </div>
          <div 
            :style="[binItem.backgroundColor]"
            style="grid-column: span 9; padding: 20px;
            display: flex; align-items: center;
            justify-content: center; border-radius: 8px;">
            <span style="color: #212121;">{{binItem?.text}}</span>
          </div>
        </div>
    
        <div v-if="binItem?.skillName !== 'Psychometry'" style="padding: 16px; box-shadow: 0px 2px 10px 0px #0000001F; border-bottom: 2px solid rgba(0, 0, 0, 0.18); border-radius: 8px; margin-bottom: 20px;">
          <div v-if="binItem?.isCoreSkill" style="font-size: 16px; font-weight: 600; margin-bottom: 16px;">{{ binItem?.skillName}}</div>
    
          <div v-if="binItem?.isCoreSkill" style="display: flex; gap: 40px; padding: 16px; background: #1B72E81F; box-shadow: 0px 2px 10px 0px #0000001F; border-bottom: 2px solid rgba(0, 0, 0, 0.18); border-radius: 8px; margin-bottom: 16px;">
            <div style="display:flex; justify-content: space-between; flex: 1">
              <span>Rank</span>
              <div style="display: flex; gap: 20px;">
                <span> - </span>
                <span> {{ binItem?.rank == 'Not Eligible' ? binItem?.rank : `#${binItem?.rank}` }} </span>
              </div>
            </div>
            <div style="display:flex; justify-content: space-between; flex: 1">
              <span>League</span>
              <div style="display: flex; gap: 20px;">
                <span> - </span>
                  <div style="display: flex; flex-direction: row;">
                    <img v-if="['gold','silver', 'bronze', 'bonze'].includes(binItem?.league?.toLowerCase())"
                    style="height:16px; width:20px; margin-right:8px;"
                    :src="getLeagueIcon(binItem?.league)"/>
                    <div>
                      {{ binItem?.league }}
                    </div>
                  </div>
              </div>
            </div>
          </div>
    
          <div style="display: flex; gap: 40px; padding: 16px; background: #B27CC433; box-shadow: 0px 2px 10px 0px #0000001F; border-bottom: 2px solid rgba(0, 0, 0, 0.18); border-radius: 8px; margin-bottom: 16px;">
            <div style="display:flex; justify-content: space-between; flex: 1">
              <span>Total Questions</span>
              <div style="display: flex; gap: 20px;">
                <span> - </span>
                <span> {{ binItem?.questionCounts?.total }} </span>
              </div>
            </div>
            <div style="display:flex; justify-content: space-between; flex: 1">
              <span>Questions Attempted</span>
              <div style="display: flex; gap: 20px;">
                <span> - </span>
                <span> {{ (binItem?.questionCounts?.correct + binItem?.questionCounts?.incorrect) }} </span>
              </div>
            </div>
          </div>
    
          <div style="display: flex; gap: 40px; padding: 16px; background: #06C27024; box-shadow: 0px 2px 10px 0px #0000001F; border-bottom: 2px solid rgba(0, 0, 0, 0.18); border-radius: 8px; margin-bottom: 16px;">
            <div style="display:flex; justify-content: space-between; flex: 1">
              <span>Correct Answers</span>
              <div style="display: flex; gap: 20px;">
                <span> - </span>
                <span> {{ binItem?.questionCounts?.correct }} </span>
              </div>
            </div>
            <div style="display:flex; justify-content: space-between; flex: 1">
              <span>Incorrect Answers</span>
              <div style="display: flex; gap: 20px;">
                <span> - </span>
                <span> {{ binItem?.questionCounts?.incorrect }} </span>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="binItem?.skillName === 'Psychometry'" style="
        box-shadow: 0px 2px 10px 0px #0000001F;
        border-bottom: 2px solid rgba(0, 0, 0, 0.18);
        border-radius: 8px;
        padding: 16px; 
        margin-bottom: 20px;">
          <div v-if="binItem?.isFirstStrand" style="margin-bottom:16px; padding:16px;">
            <div style="display: flex; gap: 40px; padding: 16px; background: #B27CC433; border-radius: 8px; margin-bottom: 16px;">
              <div style="display:flex; justify-content: space-between; flex: 1">
                <span>Total Questions</span>
                <div style="display: flex; gap: 20px;">
                  <span> - </span>
                  <span> {{ binItem?.totalQuestions }} </span>
                </div>
              </div>
              <div style="display:flex; justify-content: space-between; flex: 1">
                <span>Questions Attempted</span>
                <div style="display: flex; gap: 20px;">
                  <span> - </span>
                  <span> {{ binItem?.attemptedQuestions }} </span>
                </div>
              </div>
            </div>
            <div style="color:#212121; font-weight:600; margin-bottom: 8px;">Legend</div>
            <div>The given rating is out of 4</div>
            <v-row style="margin-top:8px;">
              <v-col style="padding:4px" cols="6">
                <div style="display: flex; justify-content: start; gap:16px">
                  <div style="width: 20px; height:20px; border-radius: 10px; font-size: 12px;" :style="selectBackgroundColor(4, true)"></div>
                  <div>Highly recommended</div>
                </div>
              </v-col>
              <v-col style="padding:4px" cols="6">
                <div style="display: flex; justify-content: start; gap:16px">
                  <div style="width: 20px; height:20px; border-radius: 10px; font-size: 12px;" :style="selectBackgroundColor(3, true)"></div>
                  <div>Recommended</div>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col style="padding:4px" cols="6">
                <div style="display: flex; justify-content: start; gap:16px">
                  <div style="width: 20px; height:20px; border-radius: 10px; font-size: 12px;" :style="selectBackgroundColor(2, true)"></div>
                  <div>Development needed</div>
                </div>
              </v-col>
              <v-col style="padding:4px" cols="6">
                <div style="display: flex; justify-content: start; gap:16px">
                  <div style="width: 20px; height:20px; border-radius: 10px; font-size: 12px;" :style="selectBackgroundColor(1, true)"></div>
                  <div>Not recommended at this time</div>
                </div>
              </v-col>
            </v-row>
          </div>
          <div style="display:flex; flex-direction:column; gap:16px; border-radius: 8px !important; box-shadow: 0px 2px 10px 0px #0000001F;border-bottom: 2px solid rgba(0, 0, 0, 0.18); padding:8px; margin-top: 8px"> 
            <div style="display: flex; justify-content:space-between">
              <div style="font-weight:600; padding:8px">{{ binItem?.strandName }}</div>
              <div style="display:flex; align-items:center; gap: 8px;">
                <div style="font-size:12px; font-weight:600;">
                  Rating
                </div>
                <div style="padding:4px;">
                  -
                </div>
                <div style="height:32px; width:56px; border-radius:28px; display:grid; place-items: center" 
                :style="selectBackgroundColor(binItem?.normalizedScore, true)">
                  {{ binItem?.normalizedScore }}
                </div>
              </div>
            </div>
            <div style="display: flex; flex-wrap: wrap;">
              <div v-for="(subStrand, index) in binItem?.subStrands" :key="index"
              style="display:flex;
              justify-content:center;
              align-items:center;
              height:32px;
              border-radius:16px; 
              background-color:#E1E8F5;
              color:#3F41D1;
              padding: 0px 16px;
              margin: 4px;
              margin-left:8px;
              font-size:12px;
              font-weight:400;" >
                {{subStrand}}
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
</div>
</template>
<script>
import CampaignController from "../controllers/CampaignController";
import { db, storage } from "../firebase";
import { collection, doc, getDocs, query, where, updateDoc, serverTimestamp, getDoc } from "firebase/firestore";
import { getDownloadURL, uploadBytes, uploadBytesResumable, ref as storageRef } from "firebase/storage";
import VueApexCharts from "vue-apexcharts";
import { cloneDeep } from "lodash";
export default {
    name: "UserPerformanceReport",
    props: {
      userId: {
        type: String,
        required: true,
        default: '',
      },
      campaignId: {
        type: String,
        required: true,
        default: ''
      }
    },
    components: {
        VueApexCharts
    },
    data() {
        return{
          advanceReport: null,
          basicReport: null,
          advanceReportBytesTransferred: 0,
          basicReportBytesTransferred: 0,
          totalPayloadSize: 0,
          retryUploadAttempts: 1,
          advancedReportURL: '',
          basicReportURL: '',
          currentDate: '',
          totalPages: 0,
          userInfo: {},
          answerProfile: [],
          scoreProfile: {},
          skillsAnalysis: [],
          skillsAnalysisForAdvanceReport: [],
          skillsAnalysisForBasicReport: [],
          recommendationLinks: [],
          nameAliases: {},
          isFocusedReport: false,
          isGtoReport: false,
          isLeadershipReport: false,
          focusedReportType: "",
          scoreDistributionChartData: [
            {
              name: 'Screening/Mains Score',
              data:[],
            },
          ],
          scoreDistributionChartOptions: {
            chart: {
              width: 600,
              height: 500,
              type: 'radar',
              toolbar: {
                show: false,
              },
              animations: {
                enabled: false,
              },
            },
            title: {
              text: '',
            },
            xaxis: {
              categories: [],
              labels: {
                show: true,
                style: {
                  colors: ["#000000DE","#000000DE","#000000DE","#000000DE","#000000DE","#000000DE", "#000000DE"],
                  fontSize: "14px",
                  fontWeight: 500,
                },
              }
            },
            stroke: {
              show: true,
              width: 2,
              colors: ["#06C270"],
              dashArray: 0,
              lineCap: 'butt',
            },
            markers: {
              size:0,
            },
            fill: {
              color: ["#06C270"],
              opacity: 0.20,
            },
            dataLabels: {
              enabled: true,
              background:{
                enabled: false,
              },
              style: {
                colors: ["#06C270"],
                fontWeight: 400,
              },
            },
            yaxis: {
              max: 10,
              min: 0,
              tickAmount: 5,
              labels: {
                show: true,
                formatter: function(val) {
                  return val
                },
                style: {
                  colors: "#666666",
                  backgroundColor: "#FBDDC2",
                  fontWeight: 350,
                },
              },
              crosshairs: {
                show: false
              },
            },
          },
          overallAssessmentChartData: [], // [Total Questions, Attempted, Correct]
          overallAssessmentChartOptions: {
            chart: {
              type: "radialBar",
              animations: {
                enabled: false
              },
              toolbar: {
                show: false
              },
            },
            plotOptions: {
              radialBar: {
                hollow: {
                  size: "20%", // Adjust the inner circle size
                },
                track: {
                  background: "#D3D3D3", // Color for the unfilled track
                  strokeWidth: 0,
                  opacity: 0.8,
                  margin: 8,
                },
                dataLabels: {
                  show: true, // Enable data labels
                  name: {
                    show: false, // Hide names (e.g., "Correct", "Attempted")
                  },
                  value: {
                    show: true, // Always show percentage values
                    fontSize: "14px", // Adjust font size for better visibility
                    formatter: function (val) {
                      return `${val}%`; // Display the percentage
                    },
                  },
                },
              },
            },
            yaxis: {
              crosshairs: {
                show: false
              }
            },
            colors: ["#1B72E8", "#B27CC4", "#06C270"], // Colors for Total, Attempted, Correct
            labels: ["Total Questions", "Attempted", "Correct"],
            legend: {
              show: true,
              position: "right", // Legend aligned to the right
              horizontalAlign: "center",
              fontSize: '14px',
              markers: {
                shape: "square",
              },
            },
          },
          donutChartOptions: {
            chart: {
              type: 'donut',
              animations: {
                enabled: false
              },
              toolbar: {
                show: false
              },
            },
            plotOptions: {
              pie: {
                donut: {
                  size: '55%',
                  offsetX: -30,
                  hollow: {
                    size: '45%',
                  },
                  labels: {
                    show: true,
                  },
                },
              },
            },
            yaxis: {
              crosshairs: {
                show: false
              }
            },
            dataLabels: {
              enabled: true,
              formatter: function (val) {
                return Number.isInteger(val)? `${val.toFixed(0)}%` : `${val.toFixed(2)}%`;
              },
              style: {
                fontSize: '14px',
                fontWeight: 400,
                colors: ['#212121']
              },
              dropShadow: {
                enabled: false
              }
            },
            legend: {
              show: true,
              position: 'right',
              fontSize: '14px',
              fontWeight: 400,
              horizontalAlign: 'center',
              markers: {
                width: 20,
                height: 12,
                shape: 'square',
                radius: 1,
              },
              labels: {
                colors: '#212121',
                useSeriesColors: false
              },
              itemMargin: {
                horizontal: 10,
                vertical: 5
              }
            },
            stroke: {
              show: false
            },
            colors: ['#06C270', '#4592FF', '#F77CAE'],
            labels: ['Strengths', 'Competency Areas', 'Areas for Improvement'],
          },
          skillTitleCardMap: {},
          allSections:[],
          advanceReportSkillsSections: [],
          advanceReportSubSection:[],
          basicReportSkillsSections: [],
          basicReportSubjectsSubSection: [],
          yourScoreImage: require('@/assets/user-score.svg'),
          highestScoreImage: require('@/assets/highest-score.svg'),
          coverPageAdvanceReport: require('@/assets/coverPage_AdvanceReport.svg'),
          coverPageBasicReport : require('@/assets/coverPage_BasicReport.svg'),
          coverPageLeadershipReport: require('@/assets/coverPage_Leadership_Advance.svg'),
          coverPageCommunicationSkillsAdvance: require('@/assets/coverPage_CommunicationSkills_Advance.svg'),
          coverPageCommunicationSkillsBasic: require('@/assets/coverPage_CommunicationSkills_Basic.svg'),
          coverPageDigitalLiteracyAdvance: require('@/assets/coverPage_DigitalLiteracy_Advance.svg'),
          coverPageDigitalLiteracyBasic: require('@/assets/coverPage_DigitalLiteracy_Basic.svg'),
          coverPageGto: require('@/assets/coverPage_GTO.svg'),
          understandYourAdvanceReport:  require('@/assets/understandYourAdvanceReport.svg'),
          understandYourBasicReport:  require('@/assets/understandYourBasicReport.svg'),
          understandYourLeadershipReport : require('@/assets/understandYourLeadershipReport.svg'),
          understandYourAdvanceCommunicationSkillsReport: require('@/assets/understandYourAdvanceCommunicationSkillsReport.svg'),
          understandYourAdvanceDigitalLiteracyReport: require('@/assets/understandYourAdvanceDigitalLiteracyReport.svg'),
          understandYourGtoReport: require('@/assets/understandYourGtoReport.svg'),
          skillTitleCardBackgroundImage: require('@/assets/SkillTitleCardBackground.svg'),
          userPerformanceReportHeaderImage: require('@/assets/performanceReportHeader.svg'),
          userPerformanceReportFooterImage: require('@/assets/performanceReportFooter.svg'),
          userAvatarPlaceholder: require('@/assets/user.png'),
          goldLeagueIcon: require('@/assets/gold.svg'),
          silverLeagueIcon: require('@/assets/silver.svg'),
          bronzeLeagueIcon: require('@/assets/bronze.svg'),
        }
    },
    async created(){
        
    },
    async mounted(){
      try{
        console.log('PDF generator mounted');
        console.time('performanceReportData')
        await this.getPerformanceReport();
        console.timeEnd('performanceReportData')
        console.time('reports generation');
        await this.generateAllReports();
        console.timeEnd('reports generation');
      }
      catch(error){
        console.error('PDF generator Failed', error);
        this.$emit('upload-failed')
      }
    },
    methods: {
      getLabelStyle(index) {
        const positions = [
          { top: "25%", left: "25.5%" }, // Position for Total Questions
          { top: "33%", left: "29%" }, // Position for Attempted
          { top: "40%", left: "32.5%" }, // Position for Correct
        ];
        return {
          position: "absolute",
          zIndex: 100, // Ensure the label appears above the chart
          top: positions[index].top,
          left: positions[index].left,
          transform: "translate(-50%, -50%)",
          fontSize: "14px",
          color: index==0?"white": "#FFFFFFF",
          fontWeight: 500,
        };
      },
      wrapPageContent(content, pageNumber, isIndexPage) {
        const wrapperTemplate = this.$refs.wrapperTemplateUserPerformanceReport.innerHTML;
        let wrappedPageContent = wrapperTemplate.replace('userPerformanceReportContent', content);
        wrappedPageContent = wrappedPageContent.replace('userPerformanceReportPageNumber', isIndexPage?"":pageNumber)
        return wrappedPageContent;
      },
      async generateAllReports(){
        if(this.isFocusedReport)
          await Promise.all([this.generateFocusedReport("advance"), this.generateFocusedReport("basic")]);

        else if(this.isGtoReport)
          await this.generateGtoReport();
          
        else
          await Promise.all([this.generateAdvanceReport(), this.generateBasicReport()]);

        this.$emit('upload-completed');
      },
      async generateAdvanceReport() {
        try {
          console.time('advance report generation')
          // Get all pages content
          const initialPages = [
            this.$refs.userPerformanceReportIndex,
            ...(this.isLeadershipReport ? [this.$refs.understandYourLeadershipReport] : [this.$refs.understandYourAdvanceReport]),
            this.$refs.userPerformanceReport1,
            this.$refs.userPerformanceReport2,
            this.$refs.userPerformanceReport3,
          ];
          const skillsPages = Array.from(
            document.querySelectorAll('div[aria-label^="skills-"]')
          );
          const recommendationLinksTemplates = this.recommendationLinks.map(( _, index)=>this.$refs[`recommendationLinksTemplate-${index}`][0]);

          const allPages = [...initialPages, ...skillsPages, ...recommendationLinksTemplates];
          this.totalPages = allPages.length + 1;

          // creating an array to represent all content and their page numbers in the UserPerformanceReport as sections
          const sections = this.createSectionsForAdvanceReport(allPages);

          // wait for DOM updates
          await this.$nextTick();
          await this.generateReport(allPages, 'advance');
          console.timeEnd('advance report generation');
        } catch (error) {
          console.error('PDF generation error:', error);
          throw error;
        }
      },
      async generateBasicReport() {
        try {
          console.time('basic report generation')

          const initialPages = [
            this.$refs.basicReportIndex,
            this.$refs.understandYourBasicReport,
            this.$refs.basicReportTemplate1,
            this.$refs.basicReportTemplate2,
          ];
          const basicReportSkillsTemplates = this.skillsAnalysisForBasicReport.map(( _, index)=>this.$refs[`basicReportSkillsTemplate-${index}`][0])
          // Get all pages content
          const allPages = [...initialPages, ...basicReportSkillsTemplates];

           // creating an array to represent all content and their page numbers in the UserPerformanceReport as sections
           this.createSectionsForBasicReport(this.isFocusedReport);
          
          // wait for DOM updates
          await this.$nextTick();
          await this.generateReport(allPages, 'basic');
            console.timeEnd('basic report generation');
        } catch (error) {
          console.error('PDF generation error:', error);
          throw error;
        }
      },
      async generateFocusedReport(reportType){
        try {
          console.time(`focused report generation ${reportType}`)
          const understandYourFocusedReport = this.getUnderstandYourReport(this.focusedReportType, reportType)

          // Get all pages content
          const initialPages = [
            reportType=='advance' ? this.$refs.userPerformanceReportIndex : this.$refs.basicReportIndex,
            understandYourFocusedReport,
            this.$refs.userPerformanceReport1,
            this.$refs.userPerformanceReport2,
          ];
          let skillsPages = Array.from(
            document.querySelectorAll('div[aria-label^="skills-"]')
          );
          skillsPages = (reportType == 'advance') ? skillsPages :  skillsPages.filter(item=>item.ariaLabel !== "skills-StrandAnalysis") 
          
          const recommendationLinksTemplates = this.recommendationLinks.map(( _, index)=>this.$refs[`recommendationLinksTemplate-${index}`][0]);

          const allPages = [
            ...initialPages,
            ...skillsPages,
            ...(reportType == 'advance'?  recommendationLinksTemplates  : [] )
          ];
          this.totalPages = allPages.length + 1;

          // creating an array to represent all content and their page numbers in the UserPerformanceReport as sections
          if(reportType === 'advance')this.createSectionsForAdvanceReport(allPages);
          else if(reportType === 'basic')this.createSectionsForBasicReport(this.isFocusedReport);
                
          // wait for DOM updates
          await this.$nextTick();
          await this.generateReport(allPages, reportType, this.isFocusedReport);
          console.timeEnd(`focused report generation ${reportType}`);

        } catch (error) {
          console.error('PDF generation error:', error);
          throw error;
        }
      },
      async generateGtoReport(){
        try {
          console.time('GTO report generation')
          // Get all pages content
          const initialPages = [
            this.$refs.userPerformanceReportIndex,
            this.$refs.understandYourGtoReport,
            this.$refs.userPerformanceReport1,
            this.$refs.userPerformanceReport2,
            this.$refs.userPerformanceReport3,
          ];
          const skillsPages = Array.from(
            document.querySelectorAll('div[aria-label^="skills-"]')
          );
          const recommendationLinksTemplates = this.recommendationLinks.map(( _, index)=>this.$refs[`recommendationLinksTemplate-${index}`][0]);

          const allPages = [...initialPages, ...skillsPages, ...recommendationLinksTemplates];
          this.totalPages = allPages.length + 1;

          // creating an array to represent all content and their page numbers in the UserPerformanceReport as sections
          const sections = this.createSectionsForAdvanceReport(allPages); // reusing advance report helper method

          // wait for DOM updates
          await this.$nextTick();
          await this.generateReport(allPages, 'advance', false, this.isGtoReport);
          console.timeEnd('GTO report generation');
        } catch (error) {
          console.error('PDF generation error:', error);
          throw error;
        }
      },
      async generateReport(allPages, reportType, isFocusedReport = false, isGtoReport = false){
        // generate filename
        const fileName = (isFocusedReport || isGtoReport) ? 
          `${this.userInfo.name}_${reportType}_${this.getCurrentDate(true)}`
          :`${this.userInfo.name}_${this.userInfo.levels[0]}_${reportType}_${this.getCurrentDate(true)}`;

        const coverPage = this.getCoverPage(isFocusedReport, this.focusedReportType, reportType);
        // create temporary container
        const container = document.createElement('div');

        //adding cover page
        container.innerHTML += coverPage.outerHTML;

        // wrapping contents of each page with header and footer templates
        allPages.forEach((page, index) => {
          let isIndexPage = false;
          if(index == 0)isIndexPage=true;

          container.innerHTML += this.wrapPageContent(page.outerHTML, index, isIndexPage);
        });

        //upload html content of report
        await CampaignController.generateReport(container.innerHTML, reportType, fileName, this.userId, this.campaignId);

        return;
      },
      async uploadAllReports(){
        try{
          this.totalBytesTransferred = 0;
          this.totalPayloadSize = this.advanceReport.size + this.basicReport.size;
          [this.advancedReportURL, this.basicReportURL] = await Promise.all([
              this.uploadReport(this.advanceReport, 'advance'),
              this.uploadReport(this.basicReport, 'basic'),
            ]);
            const audienceRef = doc(db, 'campaigns', this.campaignId, 'audience', this.userId);
            await updateDoc(audienceRef, {
                advancedReportURL: this.advancedReportURL,
                basicReportURL: this.basicReportURL,
            });
          this.$emit('upload-completed');
          return [this.advancedReportURL, this.basicReportURL];
        }
        catch(error){
          console.error('Upload Failed', error);
          throw error;
        }
      },
      async uploadReport(reportBlob, reportType) {
        try{
          if(reportType == 'advance')this.advanceReportBytesTransferred = 0;
          if(reportType == 'basic')this.basicReportBytesTransferred = 0;
          const reportRef = storageRef(storage, `user_reports/${this.userId}/${reportBlob?.fileName}`);
          const uploadTask = uploadBytesResumable(reportRef, reportBlob);
          return new Promise((resolve, reject) => {
            uploadTask.on('state_changed', 
              (snapshot) => {
                const uploadProgress = this.calculateUploadProgress(snapshot.bytesTransferred, reportType)
                this.$emit('upload-progress', uploadProgress);
              }, 
              (error) => {
                console.error(`Error uploading-${reportType}`, error)
                reject(error);
              }, 
              () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                  console.log('File available at', downloadURL);
                  resolve(downloadURL);
                }).catch((error) => {
                  console.error('Error fetching download URL', error)
                  reject(error);
                });
              }
            );
          });
        }
        catch(error){
          if(this.retryUploadAttempts > 0){
            console.error(`${reportType}report-`,error);
            this.retryUpload();
          }
          else{
            console.error(`${reportType}report-`,error);
            throw error;
          }
        }
      },
      calculateUploadProgress(bytesTransferred, reportType){
        if(reportType === 'advance')this.advanceReportBytesTransferred = bytesTransferred;
        else if(reportType === 'basic') this.basicReportBytesTransferred = bytesTransferred;

        const uploadProgress = ( (this.advanceReportBytesTransferred + this.basicReportBytesTransferred) / this.totalPayloadSize ) * 100;
        return uploadProgress;
      },
      retryUpload(reportBlob, reportType){
        this.retryUploadAttempts--;
        this.uploadReport(reportBlob, reportType);
      },
      createSectionsForAdvanceReport(allPages){
        this.allSections = [];
        let sections = [];

        sections = allPages.map((page, index) => ({
            title: page?.getAttribute('data-section-title') || `Section ${index + 1}`,
            pageNumber: index,
            considerPageNumber: !!page?.getAttribute('data-section-title'), //data-* is only defined for skills & subjects
            isCoreSkill: !!page?.getAttribute('data-section-title')?.includes("Subject"),
          }));
        //retain sections objects for the lowest page number among sections objects of the same title
        let seenTitles = new Set();
        sections.forEach((section) => {
          if (!seenTitles.has(section.title)) {
            this.allSections.push(section);
            seenTitles.add(section.title);
          }
        });

        // set subjects & skills sections
        this.advanceReportSkillsSections = this.allSections.filter(item =>
            !item.isCoreSkill 
            && item.considerPageNumber 
            && !["DoNotConsiderPageNumber", "recommendationLinks", "isMultipleSubSectionOnSamePage"].some(prefix=> item.title.startsWith(prefix))
          );
        
        this.advanceReportSkillsSections = this.advanceReportSkillsSections.flatMap(section => {
          if(section.title.startsWith("isMultipleSkillsSectionsOnSamePage")){
            return section.title.split("|")[1].split(",").map(sectionItem => ({ ...section, title: sectionItem }));
          }
          else{
            return [section];
          }
        })

        this.advanceReportSubSection = this.getAdvanceReportSubSection(this.allSections);
        return sections;
      },
      createSectionsForBasicReport(isFocusedReport = false){
        // dynamically assign page numbers for subjects/skills
        const pageNumberOffset = 4; // offsset for pages precceding 'Detailed Report' section
        const skillSection = [];
        if(!isFocusedReport){
          this.skillsAnalysisForBasicReport.forEach((grouping, index)=>{
            grouping.forEach(skillItem=>{
                  if(skillItem.isCoreSkill){
                      this.basicReportSubjectsSubSection.push({
                          ...skillItem,
                          pageNumber:index + pageNumberOffset
                      })
                      skillSection.push({
                        skillName: 'Core Skills',
                        pageNumber: index + pageNumberOffset
                      })
                  }
                  else{
                    skillSection.push({
                      ...skillItem,
                      pageNumber: index + pageNumberOffset
                    })
                  }
              })
          })
          //retain sections objects for the lowest page number among sections objects of the same title
          let seenSkillNames = new Set();
            skillSection.forEach((section) => {
              if (!seenSkillNames.has(section.skillName)) {
                this.basicReportSkillsSections.push(section);
                seenSkillNames.add(section.skillName);
              }
            });
        }
        
        // Focused report Sections:
        else{
          this.skillsAnalysis.forEach((skill, index) =>{
            this.basicReportSkillsSections.push(
              {
                skillName: 'Overall Report',
                pageNumber: index + pageNumberOffset + 1
              }
            )
          })
        }
      },
      async getPerformanceReport(){
        try {
          const response = await CampaignController.getPerformanceReport(this.userId, this.campaignId);
          if(response.flag){
            const {
                userInfo,
                answerProfile,
                scoreProfile,
                skillsAnalysis,
                recommendationLinks,
                nameAliases,
                skillTitleCardMap,
                isFocusedReport,
                isGtoReport,
                isLeadershipReport,
              } = response.data;
              
              this.nameAliases = nameAliases || {};
              this.skillTitleCardMap = skillTitleCardMap;
              this.isFocusedReport = isFocusedReport;
              this.isGtoReport = isGtoReport;
              this.isLeadershipReport = isLeadershipReport;
              
              this.userInfo = userInfo;
              this.userInfo.levels = Array.isArray(this.userInfo?.levels)? this.userInfo?.levels : [this.userInfo?.levels];
              userInfo.skillsToShow = [
                ...(userInfo.subjects || []),
                ...(userInfo.skills.filter(skill=>skill != "Core Skills").map(skill=>this.getSkillAlias(skill)))
              ];
              this.answerProfile = answerProfile;
              this.scoreProfile = scoreProfile;
              this.skillsAnalysis = cloneDeep(skillsAnalysis);

              //format Report data
              this.skillsAnalysisForAdvanceReport = this.formatSkillsAnalysisForAdvanceReport(skillsAnalysis);
              this.skillsAnalysisForBasicReport = this.formatSkillsAnalysisForBasicReport(skillsAnalysis);
              this.recommendationLinks = this.formatRecommendationLinksForReport(recommendationLinks);
              
              this.currentDate = this.getCurrentDate();
              this.focusedReportType = isFocusedReport ? skillsAnalysis[0].skillName : "";
              this.overallAssessmentChartData = [
                  100, 
                  Math.round(this.getPercentage(answerProfile.answeredQuestions, answerProfile.totalQuestions)), 
                  Math.round(this.getPercentage(answerProfile.correctAnswers, answerProfile.totalQuestions))
                ] // [Total Questions%, Attempted%, Correct%];

              this.scoreDistributionChartData[0].data = this.isGtoReport ? 
                skillsAnalysis.map(skill=>this.getPercentage(skill.score, skill.maximumMarks).toFixed(0) || 0)
                : skillsAnalysis.map(skill=>this.normalizeToTen(skill.score, skill.maximumMarks).toFixed(2) || 0);
              this.scoreDistributionChartOptions.yaxis.max = this.isGtoReport ? 100 : 10;
              this.scoreDistributionChartOptions.xaxis.categories = skillsAnalysis.map(skill=> this.getSkillAlias(skill.skillName));

              // reassigning to trigger vue reactivity
              this.scoreDistributionChartData = cloneDeep(this.scoreDistributionChartData);
              this.scoreDistributionChartOptions = cloneDeep(this.scoreDistributionChartOptions);
          }
        }
        catch(error){
          console.error(error);
          throw error;
        }
      },
      formatSkillsAnalysisForAdvanceReport(skillsAnalysis) {
        let distributedSkills = this.getDistributedSkills(skillsAnalysis); //distribute each skill into pages
        let coreSkills = distributedSkills.filter(({isCoreSkill})=>isCoreSkill);
        let otherSkills = distributedSkills.filter(({isCoreSkill})=>!isCoreSkill);
        
        const indexofSkillToAppended = !this.isLeadershipReport
          ? otherSkills.findIndex(skill=>!skill.isTitleCard && ['Psychometry', 'IKS'].includes(skill.skillName))
          : -1;

        if(indexofSkillToAppended !== -1){
          const skillToAppended = otherSkills.splice(indexofSkillToAppended, 1)[0];

          if(this.isGtoReport) otherSkills.push(skillToAppended);
          else{
            //distributing psychometry strands into three seperate psychometry clone objects, ensuring that only two strand are rendered per page.
            otherSkills.push(...this.splitPsychometryStrands(skillToAppended,'advance', 2));
          }
        }
        

        //adding Title Card before first pages of every skill
        let formattedOtherSkills = []
        otherSkills.forEach((skill)=>{
          const skillId = skill.skillName;
          const skillTitleCard = {
            ...this.skillTitleCardMap[skillId],
            ...this.nameAliases?.skills?.[skillId]?.skillTitleCardMap
          };

          if(skill.isFirstSkillsPage){
            formattedOtherSkills.push(...[skillTitleCard, skill]); // add title card before first page of each skill only
          }
          else{
            formattedOtherSkills.push(skill);
          }
        })

        const skillTitleCard = {
          ...this.skillTitleCardMap['Core Skills'],
          ...this.nameAliases?.skills?.['Core Skills']?.skillTitleCardMap
        };

        return [
         ...( (!this.isFocusedReport) ? [ skillTitleCard ] : [] ), //add coreskills titlecard manually for regular advance reports
          ...coreSkills,
          ...formattedOtherSkills
        ];
      },
      getDistributedSkills(skills) {
        let distributedSkills = [];
        skills.forEach(skill => {
          if(skill.skillName !== 'Psychometry' || this.isLeadershipReport){
            distributedSkills.push(...this.distributeStrengthWeaknessForSkill(skill, 7, 18, true));
            if(skill.strandAnalysis?.length > 0) distributedSkills.push(...this.distributeStrandsAnalysis(skill, skill.strandAnalysis));
          }
          else{
            distributedSkills.push(skill);
          }
        })
        return distributedSkills;
      },
      distributeStrengthWeaknessForSkill(
        { strengths = [], competentAreas = [], weaknesses = [], strengthsInLastPages = 0, competentAreasInLastPages = 0, weaknessesInLastPages = 0, ...rest },
        maxOnCurrentPage = 20 ,  maxPerPage = 20, isFirstInvocation = false) 
         {
        const pages = [];
        const currentPageStrengths = strengths?.slice(0, maxOnCurrentPage);
        const currentPageCompetentAreas = competentAreas?.slice(0, maxOnCurrentPage - currentPageStrengths?.length);
        const currentPageWeaknesses = weaknesses?.slice(0, maxOnCurrentPage - (currentPageCompetentAreas?.length + currentPageStrengths?.length));
        
        const remainingStrengths = strengths?.slice(maxOnCurrentPage);
        const remainingCompetentAreas = competentAreas?.slice(maxOnCurrentPage - currentPageStrengths?.length);
        const remainingWeaknesses = weaknesses?.slice(maxOnCurrentPage - (currentPageCompetentAreas?.length + currentPageStrengths?.length));

        const currentPage = {
            isFirstSkillsPage: isFirstInvocation,
            totalStrengths: strengths?.length,
            totalCompetentAreas: competentAreas?.length,
            totalWeaknesses: weaknesses?.length,
            strengths: currentPageStrengths,
            competentAreas: currentPageCompetentAreas,
            weaknesses: currentPageWeaknesses,
            strengthsInLastPages,
            competentAreasInLastPages,
            weaknessesInLastPages,
            ...rest
        };
        pages.push(currentPage);
        
        strengthsInLastPages += currentPageStrengths?.length || 0;
        competentAreasInLastPages += currentPageCompetentAreas?.length || 0;
        weaknessesInLastPages += currentPageWeaknesses?.length || 0;

        const hasMoreItems = (remainingStrengths.length > 0) || (remainingWeaknesses.length > 0) || (remainingCompetentAreas.length > 0);

        if(hasMoreItems){
          const additionalPages  = this.distributeStrengthWeaknessForSkill({
            strengths: remainingStrengths,
            competentAreas:  remainingCompetentAreas,
            weaknesses: remainingWeaknesses,
            strengthsInLastPages,
            competentAreasInLastPages,
            weaknessesInLastPages,
            ...rest}, maxPerPage);
            
            pages.push(...additionalPages);
        }
        
        return pages;
      },
      distributeStrandsAnalysis(skill, strandAnalysis){
        const pageManager = this.strandsPageManager();
        strandAnalysis.forEach((strand, index) =>{
            pageManager.initializeStrandOnCurrentPage(skill, strand.strandName, strand.strandDefinition, index );
            
            pageManager.addQuestionCountsToPage(strand.questionCounts);
            pageManager.addChartToPage([
              (strand?.strengths?.length ?? 0),
              (strand?.competentAreas?.length ?? 0),
              (strand?.weaknesses?.length ?? 0)
            ]);

            if(strand.strengths.length > 0){
                strand.strengths.forEach(strength => pageManager.addTopic("strengths", strength));
            }
            if(strand.competentAreas.length > 0){
                strand.competentAreas.forEach(competentAreas => pageManager.addTopic("competentAreas", competentAreas));
            }
            if(strand.weaknesses.length > 0){
                strand.weaknesses.forEach(weakness => pageManager.addTopic("weaknesses", weakness));
            }

        })
          const distributedStrands = pageManager.getPages();
          return distributedStrands;
      },
      strandsPageManager(initialPages = [[{}]]) {
        let pages = initialPages;
        let currentPageIndex = 0;
        let indexOfLastStrandOnPage = 0;
        let currentPageWeight = 0;
        let strenghtsInLastPage = 0;
        let competentAreasInLastPages = 0;
        let weaknessesInLastPage = 0;

        //the following weights are roughly meassured approximations of the percentage of space each content element occupies on a page
        const questionsCountWeight =  14;
        const chartWeight = 50;
        const topicsGroupTitleWeight = 4.5; // Strengths, Competency Areas & Areas for Improvement title
        const topicWeight = 4;
        const maxWeightPerPage = 100; // setting max of each page to 100%

        const moveToNextPage = () => {
          currentPageIndex++;
          indexOfLastStrandOnPage = 0;
          pages.push([{ isStrand: true }]); //initializing new strand object on each page with a strand flag
          pages[currentPageIndex][indexOfLastStrandOnPage]["strenghtsInLastPage"] = strenghtsInLastPage;
          pages[currentPageIndex][indexOfLastStrandOnPage]["competentAreasInLastPages"] = competentAreasInLastPages;
          pages[currentPageIndex][indexOfLastStrandOnPage]["weaknessesInLastPage"] = weaknessesInLastPage;
          strenghtsInLastPage = competentAreasInLastPages = weaknessesInLastPage = 0;
          currentPageWeight = 0;
        };
        
        const isPageFull = (weightToBeAdded) => {
          return (currentPageWeight + weightToBeAdded) > maxWeightPerPage; //check if element to be added on can be fitted in current page
        };
        
        const getDefinitionWeight = (definition) => {
          const totalCharacters = definition?.length ?? 0;
          const totalCharactersAllowedPerLine = 120;
          const totalWeight = Math.ceil(totalCharacters/totalCharactersAllowedPerLine) * 4;
          const definitionWeight = Math.max(1, totalWeight);
          return definitionWeight || 0;
        };
        
        const initializeStrandOnCurrentPage = (skill, strandName, strandDefinition, strandIndex) => {
          const isStrand = true;
          if(strandIndex == 0){
            pages[currentPageIndex][indexOfLastStrandOnPage] = {
              skillName: this.getSkillAlias(skill.skillName),
              skillDefinition: skill.definition,
             };
             addStrandTitleAndDefinitionToPage(isStrand, strandName, strandDefinition, true);
          }
          else{
            addStrandTitleAndDefinitionToPage(isStrand, strandName, strandDefinition );
            strenghtsInLastPage = competentAreasInLastPages = weaknessesInLastPage = 0;
          }
        };

        const addStrandTitleAndDefinitionToPage = (isStrand, strandName, strandDefinition, isFirstStrand = false) => {
          const strandDefinitionWeight = getDefinitionWeight(strandDefinition); 
          if(isPageFull(strandDefinitionWeight)) moveToNextPage();
          else indexOfLastStrandOnPage++;
          const targetStrandIndex = pages[currentPageIndex].length - 1;

          if (isFirstStrand) {
            pages[currentPageIndex].push({
              isStrand,
              strandName,
              strandDefinition,
            });
          } 
          else {
            const targetStrand = pages[currentPageIndex][indexOfLastStrandOnPage] || {};
            Object.assign(targetStrand, { isStrand, strandName, strandDefinition });
            pages[currentPageIndex][indexOfLastStrandOnPage] = targetStrand;
          }

          currentPageWeight += strandDefinitionWeight;
        };

        const addQuestionCountsToPage = (questionCounts) => {
          if(isPageFull(questionsCountWeight)) moveToNextPage();
          pages[currentPageIndex][indexOfLastStrandOnPage].questionCounts = questionCounts;
          currentPageWeight += questionsCountWeight;
        };

        const addChartToPage = (strandChartData) => {
          if(isPageFull(chartWeight)) moveToNextPage();
          pages[currentPageIndex][indexOfLastStrandOnPage].chartData = strandChartData;
          currentPageWeight += chartWeight;
        };

        const addTopic = (type, topic) => {
          // if topic type(strength, weakness) exists on page
          if(pages[currentPageIndex][indexOfLastStrandOnPage][type]){
            if(isPageFull(topicWeight)) {
              moveToNextPage();
              pages[currentPageIndex][indexOfLastStrandOnPage][type] = [topic]; // Initialize the type array on the new page
              currentPageWeight += topicWeight;
            } else {
              pages[currentPageIndex][indexOfLastStrandOnPage][type].push(topic);
              currentPageWeight += topicWeight;
            }
          }
          else{
            if(isPageFull(topicWeight + topicsGroupTitleWeight)) moveToNextPage();
            pages[currentPageIndex][indexOfLastStrandOnPage][type] = [topic];
            currentPageWeight += (topicWeight + topicsGroupTitleWeight);
          }
          if(type == "strengths")strenghtsInLastPage++;
          if(type == "competentAreas")competentAreasInLastPages++;
          if(type == "weaknesses")weaknessesInLastPage++;
        };

        return {
          moveToNextPage,
          initializeStrandOnCurrentPage,
          isPageFull,
          addQuestionCountsToPage,
          addChartToPage,
          addTopic,
          getCurrentPageIndex: () => currentPageIndex,
          getCurrentPageWeight: () => currentPageWeight,
          getPages: () => pages,
        };
      },
      splitPsychometryStrands(psychometryData, reportType, strandsPerPage = 0) {
        if (!psychometryData || !psychometryData.psychometryAnalysis || !psychometryData.psychometryAnalysis.strands) {
          return []; // Return an empty array if data is missing or empty
        }

        let splitStrands = [];
        let strands = Object.entries(psychometryData.psychometryAnalysis.strands);

        if (reportType === 'advance' && strandsPerPage > 0) {
          // Splitting psychometry strands such that each psychometry object has two strands each
          for (let i = 0; i < strands.length; i += strandsPerPage) {
            const clonedPsychometryData = cloneDeep(psychometryData);
            clonedPsychometryData.isFirstSkillsPage = (i === 0);
            clonedPsychometryData.psychometryAnalysis.strands = Object.fromEntries(strands.slice(i, i + strandsPerPage));
            splitStrands.push(clonedPsychometryData);
          }
        } else if (reportType === 'basic') {
          // Simply formatting and returning just the psychometry strands
          const totalQuestions = psychometryData.psychometryAnalysis?.metadata?.totalQuestions || 0;
          const attemptedQuestions = (psychometryData.questionCounts?.correct || 0) + (psychometryData.questionCounts?.incorrect || 0);

          splitStrands = strands.map((item, index) => ({
            skillName: 'Psychometry',
            strandName: item[0],
            ...item[1],
            ...(index === 0 && {
              isFirstStrand: true,
              totalQuestions,
              attemptedQuestions,
            }),
          }));
        }

        return splitStrands;
      },
      formatRecommendationLinksForReport(recommendationLinks){
        if(!recommendationLinks) return [];
        let recommendationLinksEntries = Object.entries(recommendationLinks);

        const consolidatedRecommendationLinks = recommendationLinksEntries.map(([skillName, recommendedReadingsForSkill]) => ({
          skillName,
          recommendedReadings: this.getConsolidatedRecommendedReadings(recommendedReadingsForSkill),
          backgroundColor: this.skillTitleCardMap[skillName]?.backgroundColor,
        }));

        return this.distributeRecommendationLinks(consolidatedRecommendationLinks); //break consolidated recommendations into pages
      },
      getConsolidatedRecommendedReadings(recommendedReadingsForSkill){
          return recommendedReadingsForSkill.reduce(
            (result, item) => {
              // result.referenceDocs.push(...item?.recommendedReadings?.referenceDocs)
              // result.videos.push(...item?.recommendedReadings?.videos)
              result.referenceDocs.push(item?.recommendedReadings?.referenceDocs[0]);
              result.videos.push(item?.recommendedReadings?.videos[0]);
              return result;
            },
            { referenceDocs: [], videos: [] }
          );
      },
      distributeRecommendationLinks(recommendationLinks) {
        const pageManager = this.recommendationsPageManager();
        
        recommendationLinks.forEach(({skillName, recommendedReadings, backgroundColor}) => {
          pageManager.initializeSkillOnCurrentPage(skillName, backgroundColor);
          
          if (recommendedReadings.videos && recommendedReadings.videos.length > 0) {
            pageManager.addSubTitleWeight();
            recommendedReadings.videos.forEach(video => {
              pageManager.addItemToPage(video, "videos");
            });
          }
          
          if (recommendedReadings.referenceDocs && recommendedReadings.referenceDocs.length > 0) {
            pageManager.addSubTitleWeight();
            recommendedReadings.referenceDocs.forEach(book => {
              pageManager.addItemToPage(book, "referenceDocs");
            });
          }
        });
        
        return pageManager.getPages();
      },
      recommendationsPageManager(initialPages = [[]]) {
        let pages = initialPages;
        let currentPageIndex = 0;
        let currentPageWeight = 0;
        const mainTitleWeight = 5;  
        const subTitleWeight = 2;
        const maxWeightPerPage = 40;
        //weights here signify lines

        const moveToNextPage = () => {
          currentPageIndex++;
          pages.push([]);
          currentPageWeight = 0;
        };
        
        const isPageFull = (isMainTitle = false, isSubTitle = false) => {
          if (isMainTitle) return (currentPageWeight + mainTitleWeight) > maxWeightPerPage;
          if (isSubTitle) return (currentPageWeight + subTitleWeight) > maxWeightPerPage;
          return currentPageWeight > maxWeightPerPage;
        };
        
        const addMainTitleWeight = () => {
          currentPageWeight += mainTitleWeight;
          return currentPageWeight;
        };
        
        const addSubTitleWeight = () => {
          currentPageWeight += subTitleWeight;
          return currentPageWeight;
        };
        
        const addItemWeight = (item) => {
          const totalCharacters = getTotalCharactersInItem(item);
          const totalCharactersAllowedPerLine = 50;
          const totalWeight = Math.floor(totalCharacters/totalCharactersAllowedPerLine);
          currentPageWeight += (totalWeight ?? 1);
          return currentPageWeight;
        };
        const getTotalCharactersInItem = (item) => {
          return Object.entries(item).reduce((totalCharacters, entry)=> {
            const lengthOfEntry = entry[1]?.length ?? 0;
            return totalCharacters += lengthOfEntry;
          },0)
        }
        const initializeSkillOnCurrentPage = (skillName, backgroundColor) => {
          if (pages[currentPageIndex].length === 0) {
            pages[currentPageIndex].push({
              skillName,
              backgroundColor,
              recommendedReadings: {
                referenceDocs: [],
                videos: []
              }
            });
            addMainTitleWeight();
          } 
          else {
            if(isPageFull(true)) moveToNextPage();
            pages[currentPageIndex].push({
              skillName,
              backgroundColor,
              recommendedReadings: {
                referenceDocs: [],
                videos: []
              }
            });
            addMainTitleWeight();
          }
        };
        
        const addItemToPage = (item, resourceType) => {
          if (isPageFull()) {
            moveToNextPage();
            
            // Create a continuation of the current skill on the new page
            const lastSkillIndex = pages[currentPageIndex - 1].length - 1;
            const lastSkill = pages[currentPageIndex - 1][lastSkillIndex];
            
            pages[currentPageIndex].push({
              skillName: lastSkill.skillName,
              backgroundColor: lastSkill.backgroundColor,
              isSkillContinued: true,
              recommendedReadings: {
                referenceDocs: [],
                videos: []
              }
            });
          }
          
          const indexOfLastSkillOnPage = pages[currentPageIndex].length - 1;
          if (indexOfLastSkillOnPage < 0) {
            console.error("No skill initialized on the current page");
            return;
          }
          
          pages[currentPageIndex][indexOfLastSkillOnPage].recommendedReadings[resourceType].push(item);
          addItemWeight(item);
        };
    
        return {
          moveToNextPage,
          isPageFull,
          addMainTitleWeight,
          addSubTitleWeight,
          addItemWeight,
          initializeSkillOnCurrentPage,
          addItemToPage,
          getCurrentPageIndex: () => currentPageIndex,
          getCurrentPageWeight: () => currentPageWeight,
          getPages: () => pages,
        };
      },
      encodeUnderscores(text) {
        return text.replace(/_/g, "%5F");
      },
      formatSkillsAnalysisForBasicReport(skillsAnalysis){
        let skillGroupings = this.makeSkillGroupings(skillsAnalysis);
        // bins base config, each bin represents a page and its items represent the subjects/skills to be rendered on that page
        const bins = [
          {items: [], max:2},
          {items: [], max:2},
          {items: [], max:2},
          {items: [], max:4},
          {items: [], max:Infinity},
        ];

        // removing unutilized bin before distributing subjects/skills into bins
        if(skillGroupings[0].length == 1) bins.pop();
        
        // distributing subjects/skills into bins
        const binManager = this.binManager(bins);
        skillGroupings.forEach((grouping) => {
          grouping?.forEach(skill => {
          if(binManager.isBinFull()){
            binManager.moveToNextBin();
            if(skill?.isFirstStrand)bins[binManager.getBinIndex()].max = 3;
          }
          binManager.addItemToBin(skill);
          })
        })
        return bins.map(bin=>bin.items);
      },
      makeSkillGroupings(skillsAnalysis){
        let coreSkills = skillsAnalysis.filter(skill=>skill.isCoreSkill);
        let otherSkills = skillsAnalysis.filter(skill=>!skill.isCoreSkill && skill.skillName !== 'Psychometry');
        let formattedPsychometryStrands = this.splitPsychometryStrands(skillsAnalysis.find(skill=>skill.skillName == 'Psychometry'), 'basic');
        
        let skillGroupings = this.addTitleCardToSkillGroupings([coreSkills, otherSkills, formattedPsychometryStrands]);

        return skillGroupings;
      },
      addTitleCardToSkillGroupings([coreSkills, otherSkills, formattedPsychometryStrands]){
        coreSkills[0] = {
          ...this.skillTitleCardMap['Core Skills'],
          ...coreSkills[0]
        }
        formattedPsychometryStrands[0] = {
          ...formattedPsychometryStrands[0],
          ...this.skillTitleCardMap['Psychometry']
        }
        otherSkills = otherSkills.map(skill=> {
          return {
            ...skill,
            ...this.skillTitleCardMap[skill.skillName]
          }
        })
        return [coreSkills, otherSkills, formattedPsychometryStrands];
      },
      binManager(bins){
        let currentBinIndex = 0;
        return {
          moveToNextBin: () => {
            if (currentBinIndex < bins.length - 1) currentBinIndex++;
          },
          isBinFull: () => bins[currentBinIndex].items.length >= bins[currentBinIndex].max,
          addItemToBin: (item) => {
            bins[currentBinIndex].items.push(item);
          },
          getBinIndex: () => currentBinIndex
        };
      },
      getSkillAlias(skillName){
        return this.nameAliases?.skills?.[skillName]?.alias || skillName;
      },
      getDataSectionTitle(skill, index){
        // for focused reports
        if(this.isFocusedReport){
          if(Array.isArray(skill)){  
            //setting data-section-title for strand section seperately
            if(skill.some(item=>item?.skillName)) return `isMultipleSkillsSectionsOnSamePage|${ skill.map(({skillName}) => skillName ?? "Strand-wise Performance").join(",")}`;
            else return `isMultipleSubSectionOnSamePage|${skill.map(({strandName}) => strandName || 'DoNotConsiderPageNumber')}`
          }
          return index === 0 ? "DoNotConsiderPageNumber" :"Overall Report";
        }
        //for regular reports
        else{
          return `${skill?.isCoreSkill ? 'Subject-': ''}${this.getSkillAlias(skill?.skillName)}`;
        }
      },
      getAdvanceReportSubSection(allSections){
        if(this.isFocusedReport){
          let subSections = [];
          
          allSections = allSections.filter(section=>section.title.startsWith("isMultipleSubSectionOnSamePage"));
          
          allSections.forEach((section, index)=>{
            // maunually prefix the first strand before other strands
            if(index == 0){
              const firstStrand = this.skillsAnalysisForAdvanceReport.flat().filter(({isStrand})=> isStrand)[0];
              subSections.push({
                title: firstStrand.strandName,
                considerPageNumber: true,
                isCoreSkill: false,
                pageNumber: Number(section?.pageNumber) - 1
              })
            }

            subSections.push([
              {...section, title: section.title.split("|")[1].split(",")[0]},
              {...section, title: section.title.split("|")[1].split(",")[1]}
            ]);
          })
          
          subSections =  subSections.flat().filter(({title})=> !["DoNotConsiderPageNumber", undefined].some(item=>item==title))
          return subSections;
        }

        else{
          return allSections.filter(section => section.isCoreSkill);
        }
      },
      getCoverPage(isFocusedReport, focusedReportType, reportType ){
        if(isFocusedReport){
          if(focusedReportType === "Communication Skills"){
            return (reportType === 'advance') ? this.$refs.coverPageCommunicationSkillsAdvance.cloneNode(true) :  this.$refs.coverPageCommunicationSkillsBasic.cloneNode(true);
          }
          else if(focusedReportType === "Digital Literacy"){
            return (reportType === 'advance') ? this.$refs.coverPageDigitalLiteracyAdvance.cloneNode(true) :  this.$refs.coverPageDigitalLiteracyBasic.cloneNode(true);
          }
        }

        else{
          if(this.isGtoReport) return this.$refs.coverPageGto.cloneNode(true);
          if(this.isLeadershipReport) return this.$refs.coverPageLeadershipReport.cloneNode(true);
          return reportType === 'advance' ? this.$refs.coverPageAdvanceReport : this.$refs.coverPageBasicReport;
        }
      },
      getUnderstandYourReport(focusedReportType, reportType ){
        if(focusedReportType === "Communication Skills"){
          return reportType=='advance' ? this.$refs.understandYourAdvanceCommunicationSkillsReport.cloneNode(true) : this.$refs.understandYourAdvanceCommunicationSkillsReport.cloneNode(true);
        }
        else if(focusedReportType === "Digital Literacy"){
          return reportType=='advance' ? this.$refs.understandYourAdvanceDigitalLiteracyReport.cloneNode(true) : this.$refs.understandYourAdvanceDigitalLiteracyReport.cloneNode(true);
        }
      },
      padWithZero(number){
        return number < 10 ? `0${number}` : `${number}`;
      },
      getPercentage(value, total){
        return (value/total)*100;
      },
      normalizeToTen(score, maxScore) {
        try{
          if(maxScore == 0 ){
            console.warn("maxScore must be a non zero value");
            return 0;
          }
          return (score / maxScore) * 10;
        }
        catch(error){
          console.error(error);
          return 0;
        }
      },
      getCurrentDate(isDateForFileName = false){
        const date = new Date();
        const day = isDateForFileName? String(date.getDate()).padStart(2, '0') : date.getDate();
        const month = isDateForFileName ? String(date.getMonth() + 1).padStart(2, '0') : date.toLocaleString('en-US', { month: 'long' });
        const year = date.getFullYear();
        const currentDate = isDateForFileName? `${day}${month}${year}` : `${month} ${day}, ${year}`;
        return currentDate;
      },
      getOrdinalSuffix(day){
        if (3 > day && day < 21) return 'th';
        switch (day % 10) {
          case 1: return 'st';
          case 2: return 'nd';
          case 3: return 'rd';
          default: return 'th';
        }
      },
      calculatePosition(value, total){
        let position = (value / total) * 100;
        return position > 90 ? 90 : position < 5 ? 5 : position;
      },
      getLeagueIcon(league){
        const leagueMap = new Map([
          ['gold', this.goldLeagueIcon],
          ['silver', this.silverLeagueIcon],
          ['bronze', this.bronzeLeagueIcon],
          ['bonze', this.bronzeLeagueIcon],
        ])
        return leagueMap.get(league.toLowerCase());
      },
      selectBackgroundColor(score, setBorderStyle = false){
        const redBox = setBorderStyle ? 
        {backgroundColor: "#D4002829", border: "1px solid #D40028", color: "#D40028" } 
        : {backgroundColor: "#D4002829"};

        const orangeBox = setBorderStyle ? 
        { backgroundColor: "#FB750029", border: "1px solid #FB7500", color: "#FB7500"}
        : { backgroundColor: "#FB750029" };

        const yellowBox = setBorderStyle ? 
        { backgroundColor: "#FADC0029", border: "1px solid #FADC00", color: "#FADC00"} 
        : { backgroundColor: "#FADC0029" };

        const greenBox = setBorderStyle ? 
        { backgroundColor: "#06C27029", border: "1px solid #06C270", color: "#06C270"}
        : {backgroundColor: "#06C27029"};

        let backgroundColorMap = new Map([
            [1, redBox],
            [2, orangeBox],
            [3, yellowBox],
            [4, greenBox]
        ])
        return backgroundColorMap.get(score);
      },
      getDottedSeparator(dottedElementHeight){
        return {
          flex: 1,
          margin: "0 8px",
          borderBottom: "0.5px dotted #212121",
          alignSelf: "center",
          height: `${dottedElementHeight}px`
        }
      },
      async waitForURLs() {
        const audienceRef = doc(db, 'campaigns', this.campaignId, 'audience', this.userId);
        let urlsAvailable = false;

        while (!urlsAvailable) {
          const audienceDoc = await getDoc(audienceRef);

          if (audienceDoc.exists()) {
            const data = audienceDoc.data();
            const advancedReportURL = data.advancedReportURL;
            const basicReportURL = data.basicReportURL;

            if (advancedReportURL && basicReportURL) {
              urlsAvailable = true;
              return { advancedReportURL, basicReportURL };
            }
          }

          // Wait for a short period before checking again
          await new Promise(resolve => setTimeout(resolve, 1000)); // Check every 1 second
        }
      }
    }
}
</script>
<style scoped>
  .page-wrapper {
    position: relative;
  }
  @media print{
    .user-performance-report {
      width: 8.27in;
      height: auto;
      margin: 0;
      font-family: "GraphikRegular", sans-serif !important;
    }
  }
</style>